<template>
    <div>
        <a>
            <div id="nc-main" class="nc-main bg-cover bg-cc">
                <div class="full-wh">
                    <!-- STAR ANIMATION -->
                    <div class="bg-animation">
                        <div id="stars"></div>
                        <div id="stars2"></div>
                        <div id="stars3"></div>
                        <div id="stars4"></div>
                        <div class="container">
                            <div class="content">
                                <div
                                    class="login-container animated fadeInDown"
                                    style="animation-delay: 0.3s"
                                >
                                    <!--   Login   -->
                                    <div
                                        class="login justify-content-center"
                                        id="login-form"
                                        v-if="
                                            chk_page === true &&
                                            chk_tk === false
                                        "
                                    >
                                        <h1 class="form-title">
                                            <!-- <v-icon
                                                style="color:#54a0ff;"
                                                size="70"
                                                >mdi-account</v-icon
                                            > -->
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/login/login.png"
                                            />

                                            <br />
                                            <span style="color: #54a0cc"
                                                >LOGIN</span
                                            >
                                            <hr />
                                        </h1>

                                        <div
                                            class="form-container animated fadeIn"
                                            style="animation-delay: 0.7s"
                                        >
                                            <label for=""
                                                ><v-icon
                                                    style="color: #7392ff"
                                                    class="mb-1 mr-1"
                                                    small
                                                    >mdi-account</v-icon
                                                >
                                                <span
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    >Username</span
                                                >
                                            </label>
                                            <input
                                                type="text"
                                                placeholder=""
                                                class="input-css"
                                                v-model="form.username"
                                                required
                                                v-on:keyup.enter="login()"
                                            />

                                            <label for=""
                                                ><v-icon
                                                    style="color: #7392ff"
                                                    class="mb-1 mr-1"
                                                    small
                                                    >mdi-pound</v-icon
                                                >
                                                <span
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    >Password</span
                                                >
                                            </label>
                                            <input
                                                type="password"
                                                class="input-css"
                                                v-model="form.password"
                                                required
                                                v-on:keyup.enter="login()"
                                            />

                                            <div class="submit-buttons">
                                                <input
                                                    type="submit"
                                                    value="Login"
                                                    @click="login()"
                                                />
                                                <input
                                                    type="button"
                                                    value="Forgot Password"
                                                    class="btn-register"
                                                    @click="get_page()"
                                                />
                                            </div>
                                            <div
                                                v-if="chk_data === true"
                                                class="text-center"
                                            >
                                                <span class="text-a"
                                                    >กรุณาล็อคอินใหม่อีกครั้ง
                                                    ..!</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <!--   Login   -->

                                    <!-- Forgot Password -->
                                    <div
                                        class="login justify-content-center"
                                        id="login-form"
                                        v-if="
                                            chk_page === false &&
                                            chk_tk === false
                                        "
                                    >
                                        <h1 class="form-title">
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/login/login.png"
                                            />
                                            <br />
                                            <span style="color: #54a0cc"
                                                >Forgot Password</span
                                            >
                                            <hr />
                                        </h1>

                                        <div
                                            class="form-container animated fadeIn"
                                            style="animation-delay: 0.7s"
                                        >
                                            <label
                                                for=""
                                                v-if="
                                                    text_data2 !=
                                                    'ทำรายการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน'
                                                "
                                                ><v-icon
                                                    style="color: #7392ff"
                                                    class="mb-1 mr-1"
                                                    small
                                                    >mdi-gmail</v-icon
                                                >
                                                <span
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    >Email</span
                                                >
                                            </label>
                                            <input
                                                v-if="
                                                    text_data2 !=
                                                    'ทำรายการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน'
                                                "
                                                type="text"
                                                placeholder=""
                                                class="input-css"
                                                v-model="form.email"
                                                required
                                                v-on:keyup.enter="email()"
                                            />

                                            <div
                                                class="submit-buttons"
                                                v-if="
                                                    text_data2 !=
                                                    'ทำรายการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน'
                                                "
                                            >
                                                <input
                                                    type="submit"
                                                    value="Send Email"
                                                    @click="email()"
                                                />
                                                <input
                                                    type="button"
                                                    value="Login"
                                                    class="btn-register"
                                                    @click="get_page()"
                                                />
                                            </div>

                                            <div
                                                v-if="chk_data2 === true"
                                                class="text-center"
                                            >
                                                <span
                                                    :class="
                                                        text_data2 ===
                                                        'ทำรายการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน'
                                                            ? 'text-b'
                                                            : 'text-a'
                                                    "
                                                    >{{ text_data2 }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <!-- For Got Password -->

                                    <!-- Reset Password -->
                                    <div
                                        class="login justify-content-center"
                                        id="login-form"
                                        v-if="chk_tk === true"
                                    >
                                        <h1 class="form-title">
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/login/login.png"
                                            />
                                            <br />
                                            <span style="color: #54a0cc"
                                                >Reset Password</span
                                            >

                                            <v-row v-if="chk_tk_email === true">
                                                <hr />
                                                <v-col cols="12">
                                                    <span class="text-bb"
                                                        >ท่านทำรายการไม่ถูกต้อง</span
                                                    ><br />
                                                    <span class="text-bb"
                                                        >กรุณราติดต่อโปรแกรมเมอร์</span
                                                    >
                                                </v-col>
                                            </v-row>
                                        </h1>

                                        <div
                                            class="form-container animated fadeIn"
                                            style="animation-delay: 0.7s"
                                            v-if="chk_tk_email === false"
                                        >
                                            <label for=""
                                                ><v-icon
                                                    style="color: #7392ff"
                                                    class="mb-1 mr-1"
                                                    small
                                                    >mdi-account</v-icon
                                                >
                                                <span
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    >Username</span
                                                >
                                            </label>

                                            <input
                                                type="text"
                                                placeholder=""
                                                class="input-css"
                                                v-model="form.username"
                                                required
                                                disabled
                                            />

                                            <label for=""
                                                ><v-icon
                                                    style="color: #7392ff"
                                                    class="mb-1 mr-1"
                                                    small
                                                    >mdi-pound</v-icon
                                                >
                                                <span
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    >Password</span
                                                >
                                            </label>
                                            <input
                                                type="password"
                                                class="input-css"
                                                v-model="form.password"
                                                required
                                                @keyup="chk_password()"
                                            />

                                            <label for=""
                                                ><v-icon
                                                    style="color: #7392ff"
                                                    class="mb-1 mr-1"
                                                    small
                                                    >mdi-pound</v-icon
                                                >
                                                <span
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    >Confirm Password
                                                </span>
                                                <span
                                                    :class="
                                                        form.password !=
                                                        form.password_confirm
                                                            ? 'text-aa'
                                                            : 'text-c'
                                                    "
                                                    v-if="chk_pass === true"
                                                >
                                                    {{
                                                        form.password !=
                                                        form.password_confirm
                                                            ? "Password not matched"
                                                            : "Password matched"
                                                    }}
                                                </span>
                                            </label>
                                            <input
                                                type="password"
                                                class="input-css"
                                                v-model="form.password_confirm"
                                                required
                                                @keyup="chk_password()"
                                                v-on:keyup.enter="
                                                    reset_password()
                                                "
                                            />

                                            <div class="submit-buttons">
                                                <input
                                                    type="submit"
                                                    value="Save Password"
                                                    @click="reset_password()"
                                                />
                                                <input
                                                    type="button"
                                                    value="Login"
                                                    class="btn-register"
                                                    @click="get_page()"
                                                />
                                            </div>
                                            <div
                                                v-if="chk_data2 === true"
                                                class="text-center"
                                            >
                                                <span class="text-a">xxx</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Reset Password -->

                                    <div
                                        class="login animated fadeIn"
                                        style="
                                            animation-delay: 0.7s;
                                            animation-duration: 4s;
                                        "
                                        id="login-bg"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- / STAR ANIMATION -->
                </div>
            </div>
        </a>

        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="450px">
                <v-card>
                    <v-card-title>
                        <span class="cus-headline"
                            >รบกวนเปลี่ยนรหัสผ่านใหม่ก่อนเข้าใช้งานระบบ</span
                        >
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <div class="input_container">
                                        <ul>
                                            <li
                                                v-bind:class="{
                                                    is_valid:
                                                        contains_eight_characters,
                                                }"
                                            >
                                                Digit อย่างน้อย 8 ตัวขึ้นไป
                                            </li>
                                            <li
                                                v-bind:class="{
                                                    is_valid: contains_number,
                                                }"
                                            >
                                                ตัวเลข อย่างน้อย 1 ตัว
                                            </li>
                                            <li
                                                v-bind:class="{
                                                    is_valid:
                                                        contains_uppercase,
                                                }"
                                            >
                                                ตัวอักษรพิมพ์ใหญ่ อย่างน้อย 1
                                                ตัว
                                            </li>
                                            <li
                                                v-bind:class="{
                                                    is_valid:
                                                        contains_special_character,
                                                }"
                                            >
                                                ตัวอักขระพิเศษ อย่างน้อย 1 ตัว
                                            </li>
                                        </ul>
                                        <small class="indigo--text"
                                            >*อ้างอิงจากประกาศนโยบายด้านความปลอดภัยของข้อมูลสารสนเทศ</small
                                        >
                                        <div
                                            class="checkmark_container"
                                            v-bind:class="{
                                                show_checkmark: valid_password,
                                            }"
                                        >
                                            <svg
                                                width="50%"
                                                height="50%"
                                                viewBox="0 0 140 100"
                                            >
                                                <path
                                                    class="checkmark"
                                                    v-bind:class="{
                                                        checked: valid_password,
                                                    }"
                                                    d="M10,50 l25,40 l95,-70"
                                                />
                                            </svg>
                                        </div>

                                        <!-- outlined
                                         type="password" -->
                                        <v-text-field
                                            :append-icon="
                                                show1
                                                    ? 'mdi-eye'
                                                    : 'mdi-eye-off'
                                            "
                                            @click:append="show1 = !show1"
                                            :type="show1 ? 'text' : 'password'"
                                            @input="checkPassword"
                                            v-model="password"
                                            autocomplete="off"
                                            placeholder="New Password"
                                            counter
                                        />
                                        <v-text-field
                                            class="mar-t-10"
                                            :append-icon="
                                                show2
                                                    ? 'mdi-eye'
                                                    : 'mdi-eye-off'
                                            "
                                            @click:append="show2 = !show2"
                                            :type="show2 ? 'text' : 'password'"
                                            @input="checkPassword2"
                                            v-model="password2"
                                            autocomplete="off"
                                            placeholder="Confirm New Password"
                                            counter
                                        />
                                    </div>
                                </v-col>
                                <v-col cols="12" class="mar-t-20">
                                    <v-btn
                                        block
                                        color="success"
                                        @click="force_reset_password()"
                                        :disabled="
                                            password2 == false ||
                                            valid_password2 == false
                                        "
                                    >
                                        Save New Password</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-container>
                        <!-- <small
                            >*อ้างอิงจากประกาศนโยบายด้านความปลอดภัยของข้อมูลสารสนเทศ</small
                        > -->
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/login/`
const url_send_mail = `${process.env.VUE_APP_ROOT_API}/api/forgetpassword`

export default {
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    mounted() {
        this.redy()
        if (this.snackbar === true) {
            setTimeout(() => {
                this.mutatesnackbar()
            }, 2000)
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        redy() {
            this.token = this.$route.params.token
            if (this.token != undefined) {
                this.chk_tk = true
                this.chk_email()
            }
        },
        async login() {
            if (this.form.username && this.form.password) {
                this.mutateIsLoading()

                await axios
                    .post(url, this.form)
                    .then((response) => {
                        // console.log(response)
                        // date.setDate(date.getDate() + 1)
                        // date.setSeconds(date.getSeconds() + 15)
                        this.chk_main_route = response.data
                        localStorage.setItem("token", response.data.token)

                        if (
                            this.chk_main_route.change_pw == "N" ||
                            this.chk_main_route.change_pw == "I"
                        ) {
                            if (this.chk_main_route.change_pw == "I") {
                                this.$swal({
                                    title: `แจ้งเตือน`,
                                    text: this.chk_main_route.change_pw_note,
                                    icon: "warning",
                                    button: false,
                                    timer: 15000,
                                })
                            }
                            let date = new Date()
                            date.setHours(date.getHours() + 2)
                            localStorage.setItem("storagetime", date)
                            localStorage.setItem("themes", response.data.themes)
                            localStorage.setItem(
                                "fullname",
                                response.data.fullname
                            )

                            localStorage.setItem(
                                "team_name",
                                response.data.team_name
                            )
                            localStorage.setItem(
                                "role_name",
                                response.data.role_name
                            )
                            localStorage.setItem(
                                "emp_img",
                                response.data.file_store_name
                            )
                            localStorage.setItem(
                                "branch_name",
                                response.data.branch_name
                            )
                            localStorage.setItem(
                                "role_type",
                                response.data.role_type
                            )
                            localStorage.setItem(
                                "travel_mode",
                                response.data.travelMode
                            )
                            localStorage.setItem(
                                "initials_en",
                                response.data.travelMode
                            )
                            localStorage.setItem(
                                "initials_th",
                                response.data.travelMode
                            )
                            

                            if (response.data.page === "Onsite") {
                                this.$root.$router.push({
                                    path: "/Onsite/Main",
                                })
                            } else if (
                                response.data.page === "Dashboard-Project"
                            ) {
                                this.$root.$router.push({ path: "/Dashboard" })
                            } else if (response.data.page === "Happycall") {
                                this.$root.$router.push({
                                    path: "/Project/hpc/index",
                                })
                            } else if (response.data.page === "Inventory") {
                                this.$root.$router.push({
                                    path: "/Inventory/Stock/",
                                })
                            } else if (response.data.page === "IT") {
                                this.$root.$router.push({
                                    path: "/Itservice/Index",
                                })
                            } else if (
                                response.data.page === "Dashboard-Management"
                            ) {
                                this.$root.$router.push({ path: "/" })
                            } else if (response.data.page === "Bench") {
                                this.$root.$router.push({
                                    path: "/Project/Bench/Onsite",
                                })
                            }
                            this.$emit("page_login")
                            this.mutateIsLoading()
                        } else {
                            // console.log(this.chk_main_route, "- new password")
                            this.dialog = true
                        }
                    })
                    .catch((error) => {
                        this.mutateIsLoading()
                        this.chk_data = true
                    })

                let tk = {
                    headers: { Authorization: "Bearer " + localStorage.token },
                }
            } else {
                this.chk_data = true
            }
        },
        async email() {
            this.mutateIsLoading()
            if (this.form) {
                await axios
                    .post(url_send_mail, this.form)
                    .then((response) => {
                        this.chk_data2 = true
                        this.text_data2 =
                            "ทำรายการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน"
                        this.mutateIsLoading()
                    })
                    .catch((error) => {
                        this.chk_data2 = true
                        this.text_data2 =
                            "อีเมลไม่ถูกต้อง กรุณาระบุอีเมลใหม่อีกครั้ง"
                        this.mutateIsLoading()
                        this.loading = false
                    })
            } else {
                this.chk_data2 = true
            }
        },
        get_page() {
            if (this.chk_tk === false) {
                this.chk_data = false
                this.chk_data2 = false
                this.chk_page = !this.chk_page
            } else {
                this.chk_page = true
                this.chk_tk = false
            }
        },
        async chk_email() {
            this.mutateIsLoading()
            await axios
                .get(url_send_mail + "/checktoken/" + this.token)
                .then((response) => {
                    this.mutateIsLoading()
                    this.form = response.data
                })
                .catch((error) => {
                    this.chk_tk_email = true
                })
        },
        async reset_password() {
            if (this.form.password === this.form.password_confirm) {
                this.mutateIsLoading()
                await axios
                    .put(url_send_mail + "/update/" + this.form.id, this.form)
                    .then((response) => {
                        this.mutatesnackbar()
                        this.mutateIsLoading()
                        this.get_page()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        checkPassword() {
            this.password_length = this.password.length
            const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

            if (this.password_length > 7) {
                this.contains_eight_characters = true
            } else {
                this.contains_eight_characters = false
            }

            this.contains_number = /\d/.test(this.password)
            this.contains_uppercase = /[A-Z]/.test(this.password)
            this.contains_special_character = format.test(this.password)

            if (
                this.contains_eight_characters === true &&
                this.contains_special_character === true &&
                this.contains_uppercase === true &&
                this.contains_number === true
            ) {
                this.valid_password = true
            } else {
                this.valid_password = false
            }
        },
        checkPassword2() {
            this.password_length = this.password.length
            const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

            if (this.password_length > 7) {
                this.contains_eight_characters = true
            } else {
                this.contains_eight_characters = false
            }

            this.contains_number = /\d/.test(this.password)
            this.contains_uppercase = /[A-Z]/.test(this.password)
            this.contains_special_character = format.test(this.password)

            if (
                this.contains_eight_characters === true &&
                this.contains_special_character === true &&
                this.contains_uppercase === true &&
                this.contains_number === true
            ) {
                if (this.password == this.password2) {
                    this.valid_password2 = true
                } else {
                    this.valid_password2 = false
                }
            } else {
                this.valid_password2 = false
            }
        },
        async force_reset_password() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }

            let pass = {
                password: this.password,
            }

            this.mutateIsLoading()
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/changepassword/`,
                    pass,
                    options
                )
                .then((response) => {
                    this.mutatesnackbar()
                    let date = new Date()
                    date.setHours(date.getHours() + 2)
                    localStorage.setItem("storagetime", date)
                    localStorage.setItem("themes", this.chk_main_route.themes)
                    localStorage.setItem(
                        "fullname",
                        this.chk_main_route.fullname
                    )

                    localStorage.setItem(
                        "team_name",
                        this.chk_main_route.team_name
                    )
                    localStorage.setItem(
                        "role_name",
                        this.chk_main_route.role_name
                    )
                    localStorage.setItem(
                        "emp_img",
                        this.chk_main_route.file_store_name
                    )
                    localStorage.setItem(
                        "branch_name",
                        this.chk_main_route.branch_name
                    )
                    localStorage.setItem(
                        "role_type",
                        this.chk_main_route.role_type
                    )
                    localStorage.setItem(
                        "travel_mode",
                        this.chk_main_route.travelMode
                    )

                    if (this.chk_main_route.page === "Onsite") {
                        this.$root.$router.push({
                            path: "/Onsite/Main",
                        })
                    } else if (
                        this.chk_main_route.page === "Dashboard-Project"
                    ) {
                        this.$root.$router.push({ path: "/Dashboard" })
                    } else if (this.chk_main_route.page === "Happycall") {
                        this.$root.$router.push({
                            path: "/Project/hpc/index",
                        })
                    } else if (this.chk_main_route.page === "Inventory") {
                        this.$root.$router.push({
                            path: "/Inventory/Stock/",
                        })
                    } else if (this.chk_main_route.page === "IT") {
                        this.$root.$router.push({
                            path: "/Itservice/Index",
                        })
                    } else if (
                        this.chk_main_route.page === "Dashboard-Management"
                    ) {
                        this.$root.$router.push({ path: "/" })
                    } else if (this.chk_main_route.page === "Bench") {
                        this.$root.$router.push({
                            path: "/Project/Bench/Onsite",
                        })
                    }
                    this.$emit("page_login")
                    this.mutateIsLoading()

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            form: {},
            chk_data: false,
            chk_data2: false,
            text_data2: "",
            chk_page: true,
            chk_tk: false,
            loader: null,
            chk_pass: false,
            chk_tk_email: false,
            text: "Success, Your work has been saved",
            chk_main_route: [],
            dialog: false,
            password: null,
            password2: null,
            password_length: 0,
            contains_eight_characters: false,
            contains_number: false,
            contains_uppercase: false,
            contains_special_character: false,
            valid_password: false,
            valid_password2: false,
            show1: false,
            show2: false,
        }
    },
    watch: {
        loader() {
            const l = this.loader
            this[l] = !this[l]
            setTimeout(() => (this[l] = false), 8000)
            this.loader = null
        },
    },
}
</script>

<style scoped>
ul {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

li {
    margin-bottom: 8px;
    color: #525f7f;
    position: relative;
}

li:before {
    content: "";
    width: 0%;
    height: 2px;
    background: #2ecc71;
    position: absolute;
    left: 0;
    top: 50%;
    display: block;
    transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.cus-headline {
    color: #214c96 !important;
    font-size: 20px;
    font-weight: bold;
}

.input_container {
    position: relative;
}

input[type="password"] {
    line-height: 1.5;
    display: block;
    color: rgba(136, 152, 170, 1);
    font-weight: 300;
    width: 100%;
    height: calc(2.75rem + 2px);
    padding: 0.625rem 0.75rem;
    border-radius: 0.25rem;
    background-color: #fff;
    transition: border-color 0.4s ease;
    border: 1px solid #cad1d7;
    outline: 0;
}

input[type="password"]:focus {
    border-color: rgba(50, 151, 211, 0.45);
}

/* Checkmark  */

.is_valid {
    color: rgba(136, 152, 170, 0.8);
}
.is_valid:before {
    width: 100%;
}

.checkmark_container {
    border-radius: 50%;
    position: absolute;
    top: -15px;
    right: -5px;
    background: #2ecc71;
    width: 30px;
    height: 30px;
    visibility: hidden;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.4s ease;
}

.show_checkmark {
    visibility: visible;
    opacity: 1;
}

.checkmark {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: white;
    stroke-width: 15;
    stroke-linecap: round;
    stroke-dasharray: 180;
    stroke-dashoffset: 180;
}

.checked {
    animation: draw 0.5s ease forwards;
}

@keyframes draw {
    to {
        stroke-dashoffset: 0;
    }
}

.content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.login-container {
    background: white;
    position: relative;
    border-radius: 5px;
    display: flex;
    width: 70vw;
    height: 70vh;
    /* box-shadow: 0 19px 38px rgba(0, 0, 0, 0.07); */
    box-shadow: 0 19px 38px rgba(118, 169, 245, 0.4);
    transition: 0.4s;
}

.login-container:hover {
    background: white;
    position: relative;
    border-radius: 5px;
    display: flex;
    width: 70vw;
    height: 70vh;
    /* box-shadow: 0 19px 38px rgba(0, 0, 0, 0.07); */
    box-shadow: 0 19px 38px rgba(132, 251, 178, 0.5);
    transition: 0.4s;
}

.login {
    transition: 0.4s;
    font-family: Comfortaa;
}

.login#login-form {
    width: 50%;
    display: block;
    padding: 15px;
    align-items: center;
    text-align: center;
    position: relative;
    margin-top: 20px;
}

.login#login-bg {
    width: 50%;
    display: inline-flex;
    /* background: url(https://picsum.photos/700); */
    background: url("../assets/login/bg-1.jpg");
    background-size: cover;
    background-position: center center;
    float: right;
    border-radius: 0 5px 5px 0;
}

.form-title {
    position: absolute;
    top: 11%;
    left: 0;
    right: 0;
    text-align: center;
    color: #dedede;
    font-size: 2.2em;
    font-family: Spartan;
    line-height: 1.4;
    margin-top: -24px;
}

.form-title hr {
    width: 75%;
    border: 2px solid #afbfd41f;
    border-radius: 10px;
    margin-top: 20px;
}

.register .form-title {
    margin-top: -54px;
}

.form-container {
    padding: 25px 10px;
    border-radius: 5px;
    width: 80%;
    text-align: left;
    margin-top: 70px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

label {
    font-size: 0.7em;
    color: #7392ff;
    margin: 0px 0 !important;
    margin-left: 4px !important;
}

input {
    background: #f8fafc;
    border: 0;
    width: 100%;
    display: block;
    padding: 10px 15px;
    border-radius: 5px;
    margin-bottom: 20px !important;
    outline: 0;
    transition: 0.4s;
}

.input-css {
    background: #edf4fc !important;
}

.input-css:hover {
    background: #f0fffa !important;
}

input::placeholder {
    opacity: 0.4;
}

.submit-buttons {
    display: flex;
}

.submit-buttons input {
    width: 50%;
    text-align: center;
    color: white;
    transition: 0.2s;
}

.submit-buttons input:hover {
    opacity: 0.7;
}

.submit-buttons input:nth-of-type(1) {
    border-radius: 5px 0 0 5px;
    background: #54a0ff;
}

.submit-buttons input:nth-of-type(1):hover {
    border-radius: 5px 0 0 5px;
    background: #23dfb0;
}

.submit-buttons input:nth-of-type(2) {
    border-radius: 0 5px 5px 0;
    background: #c8d6e5;
}

@media (max-width: 933px) {
    .login#login-bg {
        width: 0;
    }
    .login#login-form,
    .register {
        width: 100%;
    }
    input {
        width: 100%;
    }
}

.text-a {
    color: red;
}

.text-b {
    color: #54a0ff;
}

.text-aa {
    font-size: 14px !important;
    color: red;
}

.text-bb {
    font-size: 20px !important;
    color: red;
}

.text-c {
    font-size: 15px !important;
    color: #25bc03;
}

#nc-main {
    /* background-size: cover;
    height: 100%;
    position: absolute;
    width: 100%; */
    position: relative;
    height: 100vh;
    overflow-x: hidden;
    -webkit-box-shadow: 0 0 30px #241d20;
    box-shadow: 0 0 30px #241d20;
    -webkit-transition: -webkit-transform 0.4s;
    transition: -webkit-transform 0.4s;
    transition: transform 0.4s;
    transition: transform 0.4s, -webkit-transform 9s;
}

#nc-main {
    /* background-image: url("../assets/login/pexels-photo.jpg"); */
    /* background-image: url("../assets/login/bg.jpg"); */
    background-color: #05070d;
}

.full-wh {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    width: 100%;
}

.bg-animation {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.bg-animation {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

#stars {
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: 117px 1613px #fff, 1488px 635px #fff, 944px 914px #fff,
        647px 277px #fff, 1792px 1205px #fff, 656px 1517px #fff,
        820px 1839px #fff, 1153px 1400px #fff, 870px 13px #fff, 550px 702px #fff,
        1155px 1056px #fff, 88px 1709px #fff, 1450px 1090px #fff,
        1929px 457px #fff, 1390px 905px #fff, 1771px 269px #fff,
        1741px 669px #fff, 432px 64px #fff, 563px 996px #fff, 1918px 1873px #fff,
        1845px 1211px #fff, 231px 1503px #fff, 37px 220px #fff,
        1970px 495px #fff, 1812px 925px #fff, 67px 1398px #fff, 535px 279px #fff,
        1837px 829px #fff, 1945px 685px #fff, 1677px 1817px #fff,
        1317px 1415px #fff, 1785px 905px #fff, 1787px 1554px #fff,
        802px 1296px #fff, 512px 1101px #fff, 583px 1364px #fff,
        336px 558px #fff, 979px 334px #fff, 106px 792px #fff, 204px 34px #fff,
        1845px 1763px #fff, 445px 1599px #fff, 386px 453px #fff,
        471px 952px #fff, 1466px 1676px #fff, 1885px 303px #fff,
        51px 1717px #fff, 1211px 299px #fff, 1546px 1887px #fff,
        1067px 33px #fff, 1088px 1326px #fff, 1938px 760px #fff,
        470px 648px #fff, 1213px 269px #fff, 1767px 78px #fff, 977px 976px #fff,
        1926px 175px #fff, 722px 1512px #fff, 945px 227px #fff, 1811px 99px #fff,
        1912px 1406px #fff, 1602px 1243px #fff, 610px 449px #fff,
        654px 1393px #fff, 1930px 1193px #fff, 258px 1184px #fff,
        89px 265px #fff, 824px 1494px #fff, 1506px 1435px #fff,
        1027px 753px #fff, 1px 1197px #fff, 530px 1161px #fff, 864px 1555px #fff,
        1610px 1604px #fff, 1035px 1114px #fff, 1456px 133px #fff,
        1196px 1253px #fff, 361px 1037px #fff, 834px 351px #fff,
        436px 1676px #fff, 1194px 1007px #fff, 1141px 647px #fff,
        319px 454px #fff, 937px 1769px #fff, 1872px 1013px #fff,
        733px 643px #fff, 1250px 511px #fff, 189px 296px #fff, 1639px 163px #fff,
        1584px 336px #fff, 1912px 1343px #fff, 1298px 1307px #fff,
        1750px 902px #fff, 1129px 845px #fff, 1899px 1470px #fff,
        1427px 232px #fff, 1391px 838px #fff, 1225px 1819px #fff,
        190px 1366px #fff, 1865px 518px #fff, 203px 1383px #fff,
        1455px 614px #fff, 423px 354px #fff, 1678px 1790px #fff,
        241px 608px #fff, 1089px 730px #fff, 1342px 38px #fff, 1848px 249px #fff,
        1874px 1785px #fff, 1040px 1837px #fff, 751px 261px #fff,
        510px 1975px #fff, 52px 795px #fff, 1786px 1310px #fff, 498px 712px #fff,
        190px 375px #fff, 1341px 722px #fff, 43px 1394px #fff,
        1821px 1687px #fff, 106px 130px #fff, 1717px 1978px #fff,
        168px 151px #fff, 183px 740px #fff, 945px 1381px #fff, 669px 1170px #fff,
        1285px 1816px #fff, 110px 1217px #fff, 1623px 813px #fff,
        869px 647px #fff, 867px 582px #fff, 735px 1240px #fff, 519px 1896px #fff,
        132px 156px #fff, 1649px 193px #fff, 241px 1109px #fff, 643px 484px #fff,
        574px 1282px #fff, 1952px 564px #fff, 1978px 145px #fff,
        329px 903px #fff, 1674px 617px #fff, 1978px 558px #fff,
        1808px 1715px #fff, 1526px 1238px #fff, 475px 1330px #fff,
        810px 425px #fff, 1709px 634px #fff, 1658px 336px #fff, 425px 194px #fff,
        352px 96px #fff, 148px 180px #fff, 1139px 1046px #fff,
        1809px 1233px #fff, 1669px 171px #fff, 263px 1394px #fff,
        534px 715px #fff, 396px 1008px #fff, 589px 1445px #fff,
        1190px 381px #fff, 1709px 279px #fff, 520px 891px #fff,
        1136px 1867px #fff, 1280px 1233px #fff, 836px 296px #fff,
        1348px 646px #fff, 1539px 913px #fff, 423px 781px #fff,
        1271px 1805px #fff, 696px 564px #fff, 1549px 804px #fff,
        303px 1555px #fff, 1449px 1903px #fff, 66px 687px #fff,
        1164px 856px #fff, 1958px 1326px #fff, 125px 157px #fff,
        508px 1669px #fff, 465px 725px #fff, 1925px 1440px #fff,
        405px 793px #fff, 278px 110px #fff, 1084px 1065px #fff,
        1077px 705px #fff, 663px 1844px #fff, 734px 263px #fff,
        870px 1761px #fff, 103px 1169px #fff, 1506px 1295px #fff,
        1883px 926px #fff, 335px 1361px #fff, 1126px 1284px #fff,
        257px 1165px #fff, 837px 580px #fff, 1211px 1362px #fff,
        1137px 1380px #fff, 135px 632px #fff, 1491px 1965px #fff,
        1098px 195px #fff, 506px 417px #fff, 693px 1243px #fff,
        622px 1862px #fff, 1412px 1343px #fff, 948px 1894px #fff,
        1315px 1363px #fff, 754px 1098px #fff, 1931px 930px #fff,
        1831px 342px #fff, 1751px 1839px #fff, 84px 775px #fff,
        1662px 1488px #fff, 617px 1769px #fff, 1869px 1292px #fff,
        963px 432px #fff, 371px 1114px #fff, 37px 642px #fff, 21px 1184px #fff,
        602px 366px #fff, 414px 524px #fff, 282px 244px #fff, 1689px 868px #fff,
        943px 681px #fff, 898px 679px #fff, 449px 1774px #fff,
        1678px 1313px #fff, 475px 1811px #fff, 1146px 1509px #fff,
        1151px 1863px #fff, 1617px 846px #fff, 82px 1077px #fff,
        324px 1317px #fff, 1516px 885px #fff, 1706px 1526px #fff,
        1925px 1180px #fff, 553px 967px #fff, 1072px 536px #fff,
        1715px 1816px #fff, 185px 286px #fff, 1362px 1600px #fff,
        628px 1938px #fff, 1187px 412px #fff, 569px 211px #fff,
        1959px 1356px #fff, 1571px 105px #fff, 319px 1111px #fff,
        36px 1364px #fff, 502px 1788px #fff, 1051px 1993px #fff,
        1617px 773px #fff, 424px 1507px #fff, 1623px 1955px #fff,
        307px 662px #fff, 183px 1048px #fff, 1919px 1453px #fff,
        1006px 1817px #fff, 468px 673px #fff, 1142px 1375px #fff,
        1228px 443px #fff, 1734px 552px #fff, 20px 1041px #fff,
        1783px 334px #fff, 98px 1237px #fff, 1356px 1940px #fff,
        853px 1779px #fff, 1910px 560px #fff, 1174px 1656px #fff,
        110px 1724px #fff, 542px 1771px #fff, 1758px 1931px #fff,
        1463px 1401px #fff, 1155px 84px #fff, 1504px 835px #fff,
        750px 322px #fff, 407px 1900px #fff, 1600px 1141px #fff,
        657px 886px #fff, 526px 714px #fff, 18px 836px #fff, 1546px 1548px #fff,
        22px 469px #fff, 594px 1466px #fff, 1160px 1078px #fff,
        627px 1055px #fff, 195px 699px #fff, 1099px 684px #fff, 530px 551px #fff,
        1160px 1325px #fff, 894px 727px #fff, 1157px 98px #fff,
        136px 1483px #fff, 1875px 1975px #fff, 1803px 566px #fff,
        318px 1073px #fff, 1866px 1656px #fff, 543px 414px #fff,
        719px 474px #fff, 1115px 738px #fff, 353px 875px #fff, 184px 1938px #fff,
        1854px 1534px #fff, 420px 1698px #fff, 1480px 1550px #fff,
        522px 203px #fff, 1897px 1904px #fff, 975px 1708px #fff,
        1774px 602px #fff, 1908px 274px #fff, 61px 715px #fff, 983px 1156px #fff,
        326px 1013px #fff, 641px 290px #fff, 1522px 120px #fff,
        405px 1637px #fff, 1021px 1099px #fff, 631px 1145px #fff,
        982px 1967px #fff, 200px 651px #fff, 795px 351px #fff, 790px 1082px #fff,
        144px 1572px #fff, 1542px 901px #fff, 158px 1524px #fff,
        849px 1843px #fff, 1807px 203px #fff, 1747px 45px #fff,
        1603px 1738px #fff, 617px 1966px #fff, 342px 748px #fff,
        1779px 1173px #fff, 1428px 152px #fff, 589px 1998px #fff,
        1940px 1838px #fff, 115px 272px #fff, 1217px 1395px #fff,
        1402px 1491px #fff, 1833px 1814px #fff, 243px 966px #fff,
        319px 578px #fff, 813px 364px #fff, 669px 882px #fff, 551px 134px #fff,
        1819px 920px #fff, 740px 1826px #fff, 1021px 952px #fff,
        1575px 453px #fff, 324px 419px #fff, 929px 417px #fff, 885px 1112px #fff,
        503px 187px #fff, 1908px 362px #fff, 1063px 1601px #fff,
        169px 1792px #fff, 789px 963px #fff, 1697px 948px #fff,
        1761px 1810px #fff, 1844px 1591px #fff, 1709px 949px #fff,
        1402px 1396px #fff, 1037px 225px #fff, 1832px 518px #fff,
        1728px 1782px #fff, 194px 1421px #fff, 1395px 742px #fff,
        1478px 1325px #fff, 40px 593px #fff, 1732px 117px #fff, 51px 158px #fff,
        1598px 1672px #fff, 701px 849px #fff, 1403px 1979px #fff,
        145px 1414px #fff, 550px 906px #fff, 1366px 460px #fff,
        142px 1379px #fff, 34px 1864px #fff, 1346px 308px #fff, 293px 998px #fff,
        21px 1868px #fff, 540px 1033px #fff, 60px 746px #fff, 1602px 1476px #fff,
        180px 804px #fff, 345px 1982px #fff, 1439px 640px #fff,
        939px 1834px #fff, 20px 432px #fff, 492px 1549px #fff, 109px 1579px #fff,
        1796px 1403px #fff, 1079px 519px #fff, 1664px 389px #fff,
        1627px 1061px #fff, 823px 419px #fff, 1399px 1882px #fff,
        1906px 344px #fff, 1189px 848px #fff, 117px 882px #fff, 1262px 33px #fff,
        1048px 434px #fff, 1208px 1309px #fff, 1616px 408px #fff,
        1833px 853px #fff, 1433px 1656px #fff, 811px 1861px #fff,
        439px 1672px #fff, 1105px 248px #fff, 328px 1652px #fff,
        13px 1658px #fff, 685px 987px #fff, 985px 403px #fff, 1664px 1206px #fff,
        1993px 1925px #fff, 440px 917px #fff, 1835px 319px #fff,
        1404px 1907px #fff, 624px 1443px #fff, 843px 954px #fff,
        478px 1567px #fff, 895px 1602px #fff, 1231px 871px #fff,
        1267px 1646px #fff, 475px 334px #fff, 784px 796px #fff,
        1294px 199px #fff, 109px 702px #fff, 1978px 362px #fff, 291px 940px #fff,
        971px 1343px #fff, 74px 719px #fff, 36px 715px #fff, 1007px 1423px #fff,
        860px 314px #fff, 631px 177px #fff, 1900px 1590px #fff,
        1239px 1348px #fff, 1346px 1270px #fff, 1934px 1475px #fff,
        1553px 559px #fff, 588px 1969px #fff, 670px 1269px #fff,
        1484px 376px #fff, 20px 1424px #fff, 1396px 8px #fff, 969px 244px #fff,
        1807px 538px #fff, 1873px 891px #fff, 636px 1142px #fff,
        1474px 1562px #fff, 763px 350px #fff, 663px 700px #fff,
        500px 1469px #fff, 1302px 722px #fff, 181px 291px #fff, 266px 893px #fff,
        1403px 654px #fff, 492px 460px #fff, 1503px 1369px #fff,
        23px 1662px #fff, 349px 333px #fff, 1435px 1017px #fff,
        1441px 705px #fff, 1708px 1446px #fff, 1041px 911px #fff,
        1063px 780px #fff, 1158px 1356px #fff, 767px 1454px #fff,
        1912px 797px #fff, 1731px 1759px #fff, 1378px 1390px #fff,
        1815px 1364px #fff, 960px 270px #fff, 1343px 427px #fff,
        275px 203px #fff, 1319px 1092px #fff, 1455px 770px #fff,
        283px 1503px #fff, 1505px 901px #fff, 1738px 1561px #fff,
        1526px 1935px #fff, 1757px 669px #fff, 1640px 620px #fff,
        1750px 722px #fff, 748px 66px #fff, 1149px 540px #fff, 159px 953px #fff,
        200px 1426px #fff, 515px 1110px #fff, 1552px 737px #fff,
        1094px 1459px #fff, 778px 799px #fff, 1031px 523px #fff,
        743px 1825px #fff, 1100px 882px #fff, 1088px 1836px #fff,
        255px 599px #fff, 67px 1361px #fff, 247px 1721px #fff, 1722px 346px #fff,
        1822px 155px #fff, 452px 1973px #fff, 415px 1960px #fff,
        1109px 57px #fff, 273px 1392px #fff, 404px 1071px #fff,
        1212px 353px #fff, 370px 460px #fff, 795px 1523px #fff,
        1932px 340px #fff, 51px 1473px #fff, 1268px 364px #fff,
        1512px 1862px #fff, 1678px 1801px #fff, 1796px 579px #fff,
        254px 251px #fff, 1466px 1717px #fff, 893px 379px #fff,
        1153px 923px #fff, 913px 1808px #fff, 791px 789px #fff,
        417px 1924px #fff, 1336px 1599px #fff, 1695px 908px #fff,
        1120px 114px #fff, 493px 1949px #fff, 68px 1905px #fff, 969px 481px #fff,
        1420px 1095px #fff, 800px 1117px #fff, 390px 234px #fff,
        356px 1644px #fff, 1098px 1486px #fff, 1360px 521px #fff,
        149px 1198px #fff, 354px 747px #fff, 1749px 487px #fff, 470px 76px #fff,
        1672px 289px #fff, 1731px 545px #fff, 1547px 1590px #fff,
        498px 692px #fff, 398px 1592px #fff, 1846px 1237px #fff,
        1537px 1474px #fff, 1726px 1374px #fff, 1922px 858px #fff,
        376px 321px #fff, 985px 227px #fff, 234px 1421px #fff, 760px 745px #fff,
        1990px 1132px #fff, 1560px 1597px #fff, 338px 1310px #fff,
        1924px 1664px #fff, 547px 1747px #fff, 1639px 1282px #fff,
        1202px 337px #fff, 1985px 779px #fff, 737px 456px #fff, 89px 501px #fff,
        963px 792px #fff, 655px 1447px #fff, 1492px 1994px #fff,
        1171px 254px #fff, 892px 827px #fff, 1735px 442px #fff,
        1474px 1187px #fff, 846px 1518px #fff, 557px 1805px #fff,
        738px 945px #fff, 795px 68px #fff, 663px 1956px #fff, 1607px 290px #fff,
        1524px 15px #fff, 1097px 1911px #fff, 157px 1939px #fff,
        935px 1065px #fff, 1809px 1708px #fff, 164px 1157px #fff,
        83px 855px #fff, 625px 501px #fff, 814px 398px #fff, 552px 695px #fff,
        597px 1546px #fff, 1237px 1417px #fff, 628px 284px #fff,
        866px 767px #fff, 1403px 1394px #fff, 765px 1563px #fff,
        1648px 109px #fff, 1205px 1659px #fff, 921px 1313px #fff,
        1319px 243px #fff, 18px 125px #fff, 7px 777px #fff, 181px 418px #fff,
        1062px 1892px #fff, 382px 106px #fff, 994px 751px #fff, 964px 234px #fff,
        40px 118px #fff, 278px 706px #fff, 1540px 1978px #fff, 425px 1661px #fff,
        1050px 321px #fff, 735px 1729px #fff, 1438px 260px #fff,
        1229px 1109px #fff, 186px 1041px #fff, 244px 1184px #fff,
        392px 1472px #fff, 670px 1249px #fff, 1260px 1443px #fff,
        1977px 1511px #fff, 1240px 773px #fff, 303px 513px #fff,
        63px 1530px #fff, 610px 792px #fff, 1987px 1647px #fff,
        676px 1597px #fff, 1740px 1244px #fff, 816px 1661px #fff,
        351px 802px #fff, 252px 1082px #fff, 31px 365px #fff, 1453px 984px #fff,
        667px 1233px #fff, 1247px 1800px #fff, 839px 270px #fff,
        775px 913px #fff, 1966px 1398px #fff, 499px 813px #fff,
        922px 1982px #fff, 1409px 1902px #fff, 1499px 1766px #fff,
        721px 899px #fff, 788px 807px #fff, 989px 1355px #fff,
        1248px 1274px #fff, 849px 1091px #fff, 1799px 1036px #fff,
        1486px 700px #fff, 170px 1989px #fff, 1275px 799px #fff,
        772px 2000px #fff, 1642px 362px #fff, 216px 940px #fff,
        1893px 281px #fff, 1944px 1298px #fff, 1294px 400px #fff,
        1523px 441px #fff, 1829px 340px #fff, 468px 170px #fff,
        1099px 967px #fff, 1331px 665px #fff, 1174px 1553px #fff,
        1567px 325px #fff, 1028px 1399px #fff, 781px 1451px #fff,
        1912px 1954px #fff, 874px 873px #fff, 1298px 1722px #fff,
        1879px 706px #fff, 57px 1221px #fff, 1116px 1432px #fff, 48px 811px #fff,
        101px 916px #fff, 677px 304px #fff, 1203px 639px #fff, 1391px 199px #fff,
        1895px 1988px #fff, 1462px 1023px #fff, 1216px 1751px #fff,
        1261px 663px #fff, 1290px 1119px #fff, 137px 1793px #fff,
        1052px 1470px #fff, 1561px 226px #fff, 1156px 402px #fff,
        709px 693px #fff, 1040px 1911px #fff, 1624px 1115px #fff,
        551px 475px #fff, 416px 1090px #fff, 1183px 451px #fff, 58px 765px #fff,
        743px 1016px #fff, 198px 369px #fff, 1645px 1503px #fff, 997px 22px #fff,
        1447px 1323px #fff, 379px 883px #fff, 1171px 1195px #fff,
        919px 133px #fff, 1400px 517px #fff, 725px 804px #fff, 1600px 699px #fff,
        357px 581px #fff, 266px 1713px #fff, 848px 1749px #fff,
        1963px 1045px #fff, 119px 1136px #fff;
    -webkit-animation: animStar 50s linear infinite;
    -moz-animation: animStar 50s linear infinite;
    -ms-animation: animStar 50s linear infinite;
    animation: animStar 50s linear infinite;
}

#stars:after {
    content: " ";
    position: absolute;
    top: 2000px;
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: 117px 1613px #fff, 1488px 635px #fff, 944px 914px #fff,
        647px 277px #fff, 1792px 1205px #fff, 656px 1517px #fff,
        820px 1839px #fff, 1153px 1400px #fff, 870px 13px #fff, 550px 702px #fff,
        1155px 1056px #fff, 88px 1709px #fff, 1450px 1090px #fff,
        1929px 457px #fff, 1390px 905px #fff, 1771px 269px #fff,
        1741px 669px #fff, 432px 64px #fff, 563px 996px #fff, 1918px 1873px #fff,
        1845px 1211px #fff, 231px 1503px #fff, 37px 220px #fff,
        1970px 495px #fff, 1812px 925px #fff, 67px 1398px #fff, 535px 279px #fff,
        1837px 829px #fff, 1945px 685px #fff, 1677px 1817px #fff,
        1317px 1415px #fff, 1785px 905px #fff, 1787px 1554px #fff,
        802px 1296px #fff, 512px 1101px #fff, 583px 1364px #fff,
        336px 558px #fff, 979px 334px #fff, 106px 792px #fff, 204px 34px #fff,
        1845px 1763px #fff, 445px 1599px #fff, 386px 453px #fff,
        471px 952px #fff, 1466px 1676px #fff, 1885px 303px #fff,
        51px 1717px #fff, 1211px 299px #fff, 1546px 1887px #fff,
        1067px 33px #fff, 1088px 1326px #fff, 1938px 760px #fff,
        470px 648px #fff, 1213px 269px #fff, 1767px 78px #fff, 977px 976px #fff,
        1926px 175px #fff, 722px 1512px #fff, 945px 227px #fff, 1811px 99px #fff,
        1912px 1406px #fff, 1602px 1243px #fff, 610px 449px #fff,
        654px 1393px #fff, 1930px 1193px #fff, 258px 1184px #fff,
        89px 265px #fff, 824px 1494px #fff, 1506px 1435px #fff,
        1027px 753px #fff, 1px 1197px #fff, 530px 1161px #fff, 864px 1555px #fff,
        1610px 1604px #fff, 1035px 1114px #fff, 1456px 133px #fff,
        1196px 1253px #fff, 361px 1037px #fff, 834px 351px #fff,
        436px 1676px #fff, 1194px 1007px #fff, 1141px 647px #fff,
        319px 454px #fff, 937px 1769px #fff, 1872px 1013px #fff,
        733px 643px #fff, 1250px 511px #fff, 189px 296px #fff, 1639px 163px #fff,
        1584px 336px #fff, 1912px 1343px #fff, 1298px 1307px #fff,
        1750px 902px #fff, 1129px 845px #fff, 1899px 1470px #fff,
        1427px 232px #fff, 1391px 838px #fff, 1225px 1819px #fff,
        190px 1366px #fff, 1865px 518px #fff, 203px 1383px #fff,
        1455px 614px #fff, 423px 354px #fff, 1678px 1790px #fff,
        241px 608px #fff, 1089px 730px #fff, 1342px 38px #fff, 1848px 249px #fff,
        1874px 1785px #fff, 1040px 1837px #fff, 751px 261px #fff,
        510px 1975px #fff, 52px 795px #fff, 1786px 1310px #fff, 498px 712px #fff,
        190px 375px #fff, 1341px 722px #fff, 43px 1394px #fff,
        1821px 1687px #fff, 106px 130px #fff, 1717px 1978px #fff,
        168px 151px #fff, 183px 740px #fff, 945px 1381px #fff, 669px 1170px #fff,
        1285px 1816px #fff, 110px 1217px #fff, 1623px 813px #fff,
        869px 647px #fff, 867px 582px #fff, 735px 1240px #fff, 519px 1896px #fff,
        132px 156px #fff, 1649px 193px #fff, 241px 1109px #fff, 643px 484px #fff,
        574px 1282px #fff, 1952px 564px #fff, 1978px 145px #fff,
        329px 903px #fff, 1674px 617px #fff, 1978px 558px #fff,
        1808px 1715px #fff, 1526px 1238px #fff, 475px 1330px #fff,
        810px 425px #fff, 1709px 634px #fff, 1658px 336px #fff, 425px 194px #fff,
        352px 96px #fff, 148px 180px #fff, 1139px 1046px #fff,
        1809px 1233px #fff, 1669px 171px #fff, 263px 1394px #fff,
        534px 715px #fff, 396px 1008px #fff, 589px 1445px #fff,
        1190px 381px #fff, 1709px 279px #fff, 520px 891px #fff,
        1136px 1867px #fff, 1280px 1233px #fff, 836px 296px #fff,
        1348px 646px #fff, 1539px 913px #fff, 423px 781px #fff,
        1271px 1805px #fff, 696px 564px #fff, 1549px 804px #fff,
        303px 1555px #fff, 1449px 1903px #fff, 66px 687px #fff,
        1164px 856px #fff, 1958px 1326px #fff, 125px 157px #fff,
        508px 1669px #fff, 465px 725px #fff, 1925px 1440px #fff,
        405px 793px #fff, 278px 110px #fff, 1084px 1065px #fff,
        1077px 705px #fff, 663px 1844px #fff, 734px 263px #fff,
        870px 1761px #fff, 103px 1169px #fff, 1506px 1295px #fff,
        1883px 926px #fff, 335px 1361px #fff, 1126px 1284px #fff,
        257px 1165px #fff, 837px 580px #fff, 1211px 1362px #fff,
        1137px 1380px #fff, 135px 632px #fff, 1491px 1965px #fff,
        1098px 195px #fff, 506px 417px #fff, 693px 1243px #fff,
        622px 1862px #fff, 1412px 1343px #fff, 948px 1894px #fff,
        1315px 1363px #fff, 754px 1098px #fff, 1931px 930px #fff,
        1831px 342px #fff, 1751px 1839px #fff, 84px 775px #fff,
        1662px 1488px #fff, 617px 1769px #fff, 1869px 1292px #fff,
        963px 432px #fff, 371px 1114px #fff, 37px 642px #fff, 21px 1184px #fff,
        602px 366px #fff, 414px 524px #fff, 282px 244px #fff, 1689px 868px #fff,
        943px 681px #fff, 898px 679px #fff, 449px 1774px #fff,
        1678px 1313px #fff, 475px 1811px #fff, 1146px 1509px #fff,
        1151px 1863px #fff, 1617px 846px #fff, 82px 1077px #fff,
        324px 1317px #fff, 1516px 885px #fff, 1706px 1526px #fff,
        1925px 1180px #fff, 553px 967px #fff, 1072px 536px #fff,
        1715px 1816px #fff, 185px 286px #fff, 1362px 1600px #fff,
        628px 1938px #fff, 1187px 412px #fff, 569px 211px #fff,
        1959px 1356px #fff, 1571px 105px #fff, 319px 1111px #fff,
        36px 1364px #fff, 502px 1788px #fff, 1051px 1993px #fff,
        1617px 773px #fff, 424px 1507px #fff, 1623px 1955px #fff,
        307px 662px #fff, 183px 1048px #fff, 1919px 1453px #fff,
        1006px 1817px #fff, 468px 673px #fff, 1142px 1375px #fff,
        1228px 443px #fff, 1734px 552px #fff, 20px 1041px #fff,
        1783px 334px #fff, 98px 1237px #fff, 1356px 1940px #fff,
        853px 1779px #fff, 1910px 560px #fff, 1174px 1656px #fff,
        110px 1724px #fff, 542px 1771px #fff, 1758px 1931px #fff,
        1463px 1401px #fff, 1155px 84px #fff, 1504px 835px #fff,
        750px 322px #fff, 407px 1900px #fff, 1600px 1141px #fff,
        657px 886px #fff, 526px 714px #fff, 18px 836px #fff, 1546px 1548px #fff,
        22px 469px #fff, 594px 1466px #fff, 1160px 1078px #fff,
        627px 1055px #fff, 195px 699px #fff, 1099px 684px #fff, 530px 551px #fff,
        1160px 1325px #fff, 894px 727px #fff, 1157px 98px #fff,
        136px 1483px #fff, 1875px 1975px #fff, 1803px 566px #fff,
        318px 1073px #fff, 1866px 1656px #fff, 543px 414px #fff,
        719px 474px #fff, 1115px 738px #fff, 353px 875px #fff, 184px 1938px #fff,
        1854px 1534px #fff, 420px 1698px #fff, 1480px 1550px #fff,
        522px 203px #fff, 1897px 1904px #fff, 975px 1708px #fff,
        1774px 602px #fff, 1908px 274px #fff, 61px 715px #fff, 983px 1156px #fff,
        326px 1013px #fff, 641px 290px #fff, 1522px 120px #fff,
        405px 1637px #fff, 1021px 1099px #fff, 631px 1145px #fff,
        982px 1967px #fff, 200px 651px #fff, 795px 351px #fff, 790px 1082px #fff,
        144px 1572px #fff, 1542px 901px #fff, 158px 1524px #fff,
        849px 1843px #fff, 1807px 203px #fff, 1747px 45px #fff,
        1603px 1738px #fff, 617px 1966px #fff, 342px 748px #fff,
        1779px 1173px #fff, 1428px 152px #fff, 589px 1998px #fff,
        1940px 1838px #fff, 115px 272px #fff, 1217px 1395px #fff,
        1402px 1491px #fff, 1833px 1814px #fff, 243px 966px #fff,
        319px 578px #fff, 813px 364px #fff, 669px 882px #fff, 551px 134px #fff,
        1819px 920px #fff, 740px 1826px #fff, 1021px 952px #fff,
        1575px 453px #fff, 324px 419px #fff, 929px 417px #fff, 885px 1112px #fff,
        503px 187px #fff, 1908px 362px #fff, 1063px 1601px #fff,
        169px 1792px #fff, 789px 963px #fff, 1697px 948px #fff,
        1761px 1810px #fff, 1844px 1591px #fff, 1709px 949px #fff,
        1402px 1396px #fff, 1037px 225px #fff, 1832px 518px #fff,
        1728px 1782px #fff, 194px 1421px #fff, 1395px 742px #fff,
        1478px 1325px #fff, 40px 593px #fff, 1732px 117px #fff, 51px 158px #fff,
        1598px 1672px #fff, 701px 849px #fff, 1403px 1979px #fff,
        145px 1414px #fff, 550px 906px #fff, 1366px 460px #fff,
        142px 1379px #fff, 34px 1864px #fff, 1346px 308px #fff, 293px 998px #fff,
        21px 1868px #fff, 540px 1033px #fff, 60px 746px #fff, 1602px 1476px #fff,
        180px 804px #fff, 345px 1982px #fff, 1439px 640px #fff,
        939px 1834px #fff, 20px 432px #fff, 492px 1549px #fff, 109px 1579px #fff,
        1796px 1403px #fff, 1079px 519px #fff, 1664px 389px #fff,
        1627px 1061px #fff, 823px 419px #fff, 1399px 1882px #fff,
        1906px 344px #fff, 1189px 848px #fff, 117px 882px #fff, 1262px 33px #fff,
        1048px 434px #fff, 1208px 1309px #fff, 1616px 408px #fff,
        1833px 853px #fff, 1433px 1656px #fff, 811px 1861px #fff,
        439px 1672px #fff, 1105px 248px #fff, 328px 1652px #fff,
        13px 1658px #fff, 685px 987px #fff, 985px 403px #fff, 1664px 1206px #fff,
        1993px 1925px #fff, 440px 917px #fff, 1835px 319px #fff,
        1404px 1907px #fff, 624px 1443px #fff, 843px 954px #fff,
        478px 1567px #fff, 895px 1602px #fff, 1231px 871px #fff,
        1267px 1646px #fff, 475px 334px #fff, 784px 796px #fff,
        1294px 199px #fff, 109px 702px #fff, 1978px 362px #fff, 291px 940px #fff,
        971px 1343px #fff, 74px 719px #fff, 36px 715px #fff, 1007px 1423px #fff,
        860px 314px #fff, 631px 177px #fff, 1900px 1590px #fff,
        1239px 1348px #fff, 1346px 1270px #fff, 1934px 1475px #fff,
        1553px 559px #fff, 588px 1969px #fff, 670px 1269px #fff,
        1484px 376px #fff, 20px 1424px #fff, 1396px 8px #fff, 969px 244px #fff,
        1807px 538px #fff, 1873px 891px #fff, 636px 1142px #fff,
        1474px 1562px #fff, 763px 350px #fff, 663px 700px #fff,
        500px 1469px #fff, 1302px 722px #fff, 181px 291px #fff, 266px 893px #fff,
        1403px 654px #fff, 492px 460px #fff, 1503px 1369px #fff,
        23px 1662px #fff, 349px 333px #fff, 1435px 1017px #fff,
        1441px 705px #fff, 1708px 1446px #fff, 1041px 911px #fff,
        1063px 780px #fff, 1158px 1356px #fff, 767px 1454px #fff,
        1912px 797px #fff, 1731px 1759px #fff, 1378px 1390px #fff,
        1815px 1364px #fff, 960px 270px #fff, 1343px 427px #fff,
        275px 203px #fff, 1319px 1092px #fff, 1455px 770px #fff,
        283px 1503px #fff, 1505px 901px #fff, 1738px 1561px #fff,
        1526px 1935px #fff, 1757px 669px #fff, 1640px 620px #fff,
        1750px 722px #fff, 748px 66px #fff, 1149px 540px #fff, 159px 953px #fff,
        200px 1426px #fff, 515px 1110px #fff, 1552px 737px #fff,
        1094px 1459px #fff, 778px 799px #fff, 1031px 523px #fff,
        743px 1825px #fff, 1100px 882px #fff, 1088px 1836px #fff,
        255px 599px #fff, 67px 1361px #fff, 247px 1721px #fff, 1722px 346px #fff,
        1822px 155px #fff, 452px 1973px #fff, 415px 1960px #fff,
        1109px 57px #fff, 273px 1392px #fff, 404px 1071px #fff,
        1212px 353px #fff, 370px 460px #fff, 795px 1523px #fff,
        1932px 340px #fff, 51px 1473px #fff, 1268px 364px #fff,
        1512px 1862px #fff, 1678px 1801px #fff, 1796px 579px #fff,
        254px 251px #fff, 1466px 1717px #fff, 893px 379px #fff,
        1153px 923px #fff, 913px 1808px #fff, 791px 789px #fff,
        417px 1924px #fff, 1336px 1599px #fff, 1695px 908px #fff,
        1120px 114px #fff, 493px 1949px #fff, 68px 1905px #fff, 969px 481px #fff,
        1420px 1095px #fff, 800px 1117px #fff, 390px 234px #fff,
        356px 1644px #fff, 1098px 1486px #fff, 1360px 521px #fff,
        149px 1198px #fff, 354px 747px #fff, 1749px 487px #fff, 470px 76px #fff,
        1672px 289px #fff, 1731px 545px #fff, 1547px 1590px #fff,
        498px 692px #fff, 398px 1592px #fff, 1846px 1237px #fff,
        1537px 1474px #fff, 1726px 1374px #fff, 1922px 858px #fff,
        376px 321px #fff, 985px 227px #fff, 234px 1421px #fff, 760px 745px #fff,
        1990px 1132px #fff, 1560px 1597px #fff, 338px 1310px #fff,
        1924px 1664px #fff, 547px 1747px #fff, 1639px 1282px #fff,
        1202px 337px #fff, 1985px 779px #fff, 737px 456px #fff, 89px 501px #fff,
        963px 792px #fff, 655px 1447px #fff, 1492px 1994px #fff,
        1171px 254px #fff, 892px 827px #fff, 1735px 442px #fff,
        1474px 1187px #fff, 846px 1518px #fff, 557px 1805px #fff,
        738px 945px #fff, 795px 68px #fff, 663px 1956px #fff, 1607px 290px #fff,
        1524px 15px #fff, 1097px 1911px #fff, 157px 1939px #fff,
        935px 1065px #fff, 1809px 1708px #fff, 164px 1157px #fff,
        83px 855px #fff, 625px 501px #fff, 814px 398px #fff, 552px 695px #fff,
        597px 1546px #fff, 1237px 1417px #fff, 628px 284px #fff,
        866px 767px #fff, 1403px 1394px #fff, 765px 1563px #fff,
        1648px 109px #fff, 1205px 1659px #fff, 921px 1313px #fff,
        1319px 243px #fff, 18px 125px #fff, 7px 777px #fff, 181px 418px #fff,
        1062px 1892px #fff, 382px 106px #fff, 994px 751px #fff, 964px 234px #fff,
        40px 118px #fff, 278px 706px #fff, 1540px 1978px #fff, 425px 1661px #fff,
        1050px 321px #fff, 735px 1729px #fff, 1438px 260px #fff,
        1229px 1109px #fff, 186px 1041px #fff, 244px 1184px #fff,
        392px 1472px #fff, 670px 1249px #fff, 1260px 1443px #fff,
        1977px 1511px #fff, 1240px 773px #fff, 303px 513px #fff,
        63px 1530px #fff, 610px 792px #fff, 1987px 1647px #fff,
        676px 1597px #fff, 1740px 1244px #fff, 816px 1661px #fff,
        351px 802px #fff, 252px 1082px #fff, 31px 365px #fff, 1453px 984px #fff,
        667px 1233px #fff, 1247px 1800px #fff, 839px 270px #fff,
        775px 913px #fff, 1966px 1398px #fff, 499px 813px #fff,
        922px 1982px #fff, 1409px 1902px #fff, 1499px 1766px #fff,
        721px 899px #fff, 788px 807px #fff, 989px 1355px #fff,
        1248px 1274px #fff, 849px 1091px #fff, 1799px 1036px #fff,
        1486px 700px #fff, 170px 1989px #fff, 1275px 799px #fff,
        772px 2000px #fff, 1642px 362px #fff, 216px 940px #fff,
        1893px 281px #fff, 1944px 1298px #fff, 1294px 400px #fff,
        1523px 441px #fff, 1829px 340px #fff, 468px 170px #fff,
        1099px 967px #fff, 1331px 665px #fff, 1174px 1553px #fff,
        1567px 325px #fff, 1028px 1399px #fff, 781px 1451px #fff,
        1912px 1954px #fff, 874px 873px #fff, 1298px 1722px #fff,
        1879px 706px #fff, 57px 1221px #fff, 1116px 1432px #fff, 48px 811px #fff,
        101px 916px #fff, 677px 304px #fff, 1203px 639px #fff, 1391px 199px #fff,
        1895px 1988px #fff, 1462px 1023px #fff, 1216px 1751px #fff,
        1261px 663px #fff, 1290px 1119px #fff, 137px 1793px #fff,
        1052px 1470px #fff, 1561px 226px #fff, 1156px 402px #fff,
        709px 693px #fff, 1040px 1911px #fff, 1624px 1115px #fff,
        551px 475px #fff, 416px 1090px #fff, 1183px 451px #fff, 58px 765px #fff,
        743px 1016px #fff, 198px 369px #fff, 1645px 1503px #fff, 997px 22px #fff,
        1447px 1323px #fff, 379px 883px #fff, 1171px 1195px #fff,
        919px 133px #fff, 1400px 517px #fff, 725px 804px #fff, 1600px 699px #fff,
        357px 581px #fff, 266px 1713px #fff, 848px 1749px #fff,
        1963px 1045px #fff, 119px 1136px #fff;
}

#stars2 {
    width: 2px;
    height: 2px;
    background: transparent;
    box-shadow: 1117px 1306px #fff, 1078px 1783px #fff, 1179px 1085px #fff,
        1145px 920px #fff, 422px 1233px #fff, 387px 98px #fff, 1153px 637px #fff,
        1084px 782px #fff, 476px 453px #fff, 926px 1306px #fff, 60px 1086px #fff,
        753px 1575px #fff, 272px 1684px #fff, 1285px 750px #fff,
        1416px 1327px #fff, 1931px 473px #fff, 736px 1395px #fff,
        1816px 763px #fff, 438px 879px #fff, 665px 1902px #fff,
        1341px 677px #fff, 1404px 1073px #fff, 100px 597px #fff,
        357px 1689px #fff, 1044px 1342px #fff, 1954px 502px #fff,
        1192px 1308px #fff, 540px 1239px #fff, 1360px 552px #fff,
        89px 752px #fff, 659px 1253px #fff, 62px 517px #fff, 1375px 1705px #fff,
        1343px 1511px #fff, 1659px 1922px #fff, 1560px 289px #fff,
        1362px 1799px #fff, 1886px 1480px #fff, 1718px 1885px #fff,
        824px 738px #fff, 1060px 1370px #fff, 1781px 1171px #fff,
        255px 273px #fff, 1197px 120px #fff, 213px 7px #fff, 1226px 1920px #fff,
        1844px 207px #fff, 1675px 970px #fff, 1435px 1283px #fff,
        37px 353px #fff, 59px 417px #fff, 921px 1602px #fff, 1549px 1490px #fff,
        638px 1845px #fff, 1328px 198px #fff, 1050px 1149px #fff,
        1884px 711px #fff, 333px 263px #fff, 342px 1508px #fff,
        1388px 1810px #fff, 1377px 1558px #fff, 890px 487px #fff,
        1081px 759px #fff, 890px 1515px #fff, 911px 1284px #fff,
        335px 735px #fff, 1140px 549px #fff, 1239px 1064px #fff, 226px 71px #fff,
        1100px 1278px #fff, 1851px 1805px #fff, 1370px 1999px #fff,
        1008px 1122px #fff, 785px 813px #fff, 1358px 601px #fff,
        1833px 1305px #fff, 1768px 1304px #fff, 1303px 532px #fff,
        860px 598px #fff, 1329px 593px #fff, 1038px 1088px #fff,
        408px 405px #fff, 965px 82px #fff, 1483px 1438px #fff, 310px 1479px #fff,
        1786px 1500px #fff, 1866px 852px #fff, 18px 1757px #fff,
        1473px 1004px #fff, 1542px 1933px #fff, 633px 1970px #fff,
        1334px 1713px #fff, 175px 28px #fff, 592px 894px #fff, 121px 1162px #fff,
        1601px 1567px #fff, 1095px 657px #fff, 640px 1233px #fff,
        1073px 1255px #fff, 840px 1087px #fff, 718px 250px #fff,
        967px 709px #fff, 731px 239px #fff, 1623px 593px #fff,
        1058px 1820px #fff, 516px 1898px #fff, 666px 12px #fff,
        1997px 1382px #fff, 112px 1690px #fff, 687px 1309px #fff,
        63px 539px #fff, 185px 1897px #fff, 1055px 1691px #fff,
        435px 1517px #fff, 1175px 1119px #fff, 1721px 133px #fff,
        1212px 47px #fff, 166px 18px #fff, 1416px 1652px #fff,
        1409px 1745px #fff, 1357px 1232px #fff, 1677px 1998px #fff,
        448px 1415px #fff, 705px 1736px #fff, 1031px 1466px #fff,
        543px 1651px #fff, 1592px 1888px #fff, 1749px 1175px #fff,
        639px 1114px #fff, 1591px 508px #fff, 759px 1244px #fff,
        824px 380px #fff, 942px 955px #fff, 723px 732px #fff, 113px 1369px #fff,
        203px 1739px #fff, 868px 733px #fff, 713px 971px #fff, 341px 833px #fff,
        762px 824px #fff, 1359px 310px #fff, 1858px 1349px #fff,
        1531px 692px #fff, 1075px 1512px #fff, 1677px 142px #fff,
        1912px 1478px #fff, 1810px 1078px #fff, 426px 844px #fff,
        1426px 588px #fff, 1909px 654px #fff, 1107px 295px #fff,
        1351px 527px #fff, 1393px 599px #fff, 1379px 1068px #fff,
        228px 1846px #fff, 1271px 374px #fff, 1348px 612px #fff, 7px 1301px #fff,
        1501px 1782px #fff, 1795px 423px #fff, 1475px 1918px #fff,
        1328px 1861px #fff, 1624px 51px #fff, 1791px 672px #fff,
        1594px 1467px #fff, 1655px 1603px #fff, 919px 850px #fff,
        523px 609px #fff, 1196px 207px #fff, 753px 410px #fff, 686px 1097px #fff,
        1570px 133px #fff, 1996px 1137px #fff, 361px 116px #fff,
        1015px 462px #fff, 76px 1143px #fff, 491px 1818px #fff,
        1563px 795px #fff, 982px 1721px #fff, 831px 1204px #fff,
        1737px 589px #fff, 861px 1579px #fff, 1666px 130px #fff,
        698px 1799px #fff, 726px 1519px #fff, 109px 1208px #fff,
        1184px 1057px #fff, 835px 451px #fff, 896px 594px #fff, 35px 893px #fff,
        895px 542px #fff, 706px 225px #fff, 56px 1040px #fff, 1954px 108px #fff,
        1439px 1423px #fff, 26px 1881px #fff, 802px 1564px #fff,
        273px 708px #fff, 40px 31px #fff, 859px 108px #fff;
    -webkit-animation: animStar 100s linear infinite;
    -moz-animation: animStar 100s linear infinite;
    -ms-animation: animStar 100s linear infinite;
    animation: animStar 100s linear infinite;
}

#stars2:after {
    content: " ";
    position: absolute;
    top: 2000px;
    width: 2px;
    height: 2px;
    background: transparent;
    box-shadow: 1117px 1306px #fff, 1078px 1783px #fff, 1179px 1085px #fff,
        1145px 920px #fff, 422px 1233px #fff, 387px 98px #fff, 1153px 637px #fff,
        1084px 782px #fff, 476px 453px #fff, 926px 1306px #fff, 60px 1086px #fff,
        753px 1575px #fff, 272px 1684px #fff, 1285px 750px #fff,
        1416px 1327px #fff, 1931px 473px #fff, 736px 1395px #fff,
        1816px 763px #fff, 438px 879px #fff, 665px 1902px #fff,
        1341px 677px #fff, 1404px 1073px #fff, 100px 597px #fff,
        357px 1689px #fff, 1044px 1342px #fff, 1954px 502px #fff,
        1192px 1308px #fff, 540px 1239px #fff, 1360px 552px #fff,
        89px 752px #fff, 659px 1253px #fff, 62px 517px #fff, 1375px 1705px #fff,
        1343px 1511px #fff, 1659px 1922px #fff, 1560px 289px #fff,
        1362px 1799px #fff, 1886px 1480px #fff, 1718px 1885px #fff,
        824px 738px #fff, 1060px 1370px #fff, 1781px 1171px #fff,
        255px 273px #fff, 1197px 120px #fff, 213px 7px #fff, 1226px 1920px #fff,
        1844px 207px #fff, 1675px 970px #fff, 1435px 1283px #fff,
        37px 353px #fff, 59px 417px #fff, 921px 1602px #fff, 1549px 1490px #fff,
        638px 1845px #fff, 1328px 198px #fff, 1050px 1149px #fff,
        1884px 711px #fff, 333px 263px #fff, 342px 1508px #fff,
        1388px 1810px #fff, 1377px 1558px #fff, 890px 487px #fff,
        1081px 759px #fff, 890px 1515px #fff, 911px 1284px #fff,
        335px 735px #fff, 1140px 549px #fff, 1239px 1064px #fff, 226px 71px #fff,
        1100px 1278px #fff, 1851px 1805px #fff, 1370px 1999px #fff,
        1008px 1122px #fff, 785px 813px #fff, 1358px 601px #fff,
        1833px 1305px #fff, 1768px 1304px #fff, 1303px 532px #fff,
        860px 598px #fff, 1329px 593px #fff, 1038px 1088px #fff,
        408px 405px #fff, 965px 82px #fff, 1483px 1438px #fff, 310px 1479px #fff,
        1786px 1500px #fff, 1866px 852px #fff, 18px 1757px #fff,
        1473px 1004px #fff, 1542px 1933px #fff, 633px 1970px #fff,
        1334px 1713px #fff, 175px 28px #fff, 592px 894px #fff, 121px 1162px #fff,
        1601px 1567px #fff, 1095px 657px #fff, 640px 1233px #fff,
        1073px 1255px #fff, 840px 1087px #fff, 718px 250px #fff,
        967px 709px #fff, 731px 239px #fff, 1623px 593px #fff,
        1058px 1820px #fff, 516px 1898px #fff, 666px 12px #fff,
        1997px 1382px #fff, 112px 1690px #fff, 687px 1309px #fff,
        63px 539px #fff, 185px 1897px #fff, 1055px 1691px #fff,
        435px 1517px #fff, 1175px 1119px #fff, 1721px 133px #fff,
        1212px 47px #fff, 166px 18px #fff, 1416px 1652px #fff,
        1409px 1745px #fff, 1357px 1232px #fff, 1677px 1998px #fff,
        448px 1415px #fff, 705px 1736px #fff, 1031px 1466px #fff,
        543px 1651px #fff, 1592px 1888px #fff, 1749px 1175px #fff,
        639px 1114px #fff, 1591px 508px #fff, 759px 1244px #fff,
        824px 380px #fff, 942px 955px #fff, 723px 732px #fff, 113px 1369px #fff,
        203px 1739px #fff, 868px 733px #fff, 713px 971px #fff, 341px 833px #fff,
        762px 824px #fff, 1359px 310px #fff, 1858px 1349px #fff,
        1531px 692px #fff, 1075px 1512px #fff, 1677px 142px #fff,
        1912px 1478px #fff, 1810px 1078px #fff, 426px 844px #fff,
        1426px 588px #fff, 1909px 654px #fff, 1107px 295px #fff,
        1351px 527px #fff, 1393px 599px #fff, 1379px 1068px #fff,
        228px 1846px #fff, 1271px 374px #fff, 1348px 612px #fff, 7px 1301px #fff,
        1501px 1782px #fff, 1795px 423px #fff, 1475px 1918px #fff,
        1328px 1861px #fff, 1624px 51px #fff, 1791px 672px #fff,
        1594px 1467px #fff, 1655px 1603px #fff, 919px 850px #fff,
        523px 609px #fff, 1196px 207px #fff, 753px 410px #fff, 686px 1097px #fff,
        1570px 133px #fff, 1996px 1137px #fff, 361px 116px #fff,
        1015px 462px #fff, 76px 1143px #fff, 491px 1818px #fff,
        1563px 795px #fff, 982px 1721px #fff, 831px 1204px #fff,
        1737px 589px #fff, 861px 1579px #fff, 1666px 130px #fff,
        698px 1799px #fff, 726px 1519px #fff, 109px 1208px #fff,
        1184px 1057px #fff, 835px 451px #fff, 896px 594px #fff, 35px 893px #fff,
        895px 542px #fff, 706px 225px #fff, 56px 1040px #fff, 1954px 108px #fff,
        1439px 1423px #fff, 26px 1881px #fff, 802px 1564px #fff,
        273px 708px #fff, 40px 31px #fff, 859px 108px #fff;
}

#stars3 {
    width: 3px;
    height: 3px;
    background: transparent;
    box-shadow: 940px 1360px #fff, 1071px 539px #fff, 1710px 1414px #fff,
        836px 299px #fff, 1944px 1420px #fff, 253px 1449px #fff,
        1257px 1250px #fff, 1588px 1830px #fff, 1077px 1204px #fff,
        273px 1081px #fff, 1993px 766px #fff, 1808px 479px #fff,
        917px 263px #fff, 663px 1820px #fff, 342px 1988px #fff,
        727px 1250px #fff, 636px 1666px #fff, 692px 1112px #fff,
        248px 1211px #fff, 1422px 1121px #fff, 881px 46px #fff,
        1531px 1977px #fff, 1643px 1023px #fff, 684px 1071px #fff,
        1142px 1873px #fff, 292px 1313px #fff, 256px 1237px #fff,
        89px 912px #fff, 964px 1783px #fff, 877px 760px #fff, 1641px 1474px #fff,
        1492px 24px #fff, 1776px 1642px #fff, 183px 602px #fff, 1998px 62px #fff,
        1560px 367px #fff, 1333px 995px #fff, 704px 1815px #fff,
        1809px 712px #fff, 1503px 288px #fff, 630px 556px #fff,
        1715px 125px #fff, 353px 1878px #fff, 975px 333px #fff,
        1740px 1409px #fff, 1341px 1871px #fff, 1279px 1064px #fff,
        169px 874px #fff, 161px 528px #fff, 1671px 1669px #fff, 169px 632px #fff,
        547px 1724px #fff, 1904px 110px #fff, 679px 1670px #fff,
        196px 123px #fff, 786px 871px #fff, 1840px 324px #fff, 356px 967px #fff,
        61px 549px #fff, 99px 677px #fff, 1719px 87px #fff, 1713px 1990px #fff,
        1717px 1358px #fff, 108px 1187px #fff, 51px 869px #fff,
        1461px 902px #fff, 1034px 891px #fff, 962px 1881px #fff,
        1723px 595px #fff, 479px 901px #fff, 1546px 1823px #fff,
        285px 1208px #fff, 1056px 347px #fff, 261px 988px #fff, 466px 990px #fff,
        1657px 648px #fff, 1249px 933px #fff, 1552px 1555px #fff,
        147px 62px #fff, 292px 1157px #fff, 1816px 423px #fff, 1714px 757px #fff,
        1036px 961px #fff, 1955px 710px #fff, 1842px 516px #fff,
        479px 1870px #fff, 1579px 1445px #fff, 1225px 1309px #fff,
        1965px 566px #fff, 1575px 1072px #fff, 923px 329px #fff,
        651px 1514px #fff, 865px 1100px #fff, 782px 1873px #fff,
        115px 299px #fff, 14px 1668px #fff, 1666px 1817px #fff,
        1096px 1068px #fff, 1462px 742px #fff, 1384px 1750px #fff;
    -webkit-animation: animStar 150s linear infinite;
    -moz-animation: animStar 150s linear infinite;
    -ms-animation: animStar 150s linear infinite;
    animation: animStar 150s linear infinite;
}

#stars3:after {
    content: " ";
    position: absolute;
    top: 2000px;
    width: 3px;
    height: 3px;
    background: transparent;
    box-shadow: 940px 1360px #fff, 1071px 539px #fff, 1710px 1414px #fff,
        836px 299px #fff, 1944px 1420px #fff, 253px 1449px #fff,
        1257px 1250px #fff, 1588px 1830px #fff, 1077px 1204px #fff,
        273px 1081px #fff, 1993px 766px #fff, 1808px 479px #fff,
        917px 263px #fff, 663px 1820px #fff, 342px 1988px #fff,
        727px 1250px #fff, 636px 1666px #fff, 692px 1112px #fff,
        248px 1211px #fff, 1422px 1121px #fff, 881px 46px #fff,
        1531px 1977px #fff, 1643px 1023px #fff, 684px 1071px #fff,
        1142px 1873px #fff, 292px 1313px #fff, 256px 1237px #fff,
        89px 912px #fff, 964px 1783px #fff, 877px 760px #fff, 1641px 1474px #fff,
        1492px 24px #fff, 1776px 1642px #fff, 183px 602px #fff, 1998px 62px #fff,
        1560px 367px #fff, 1333px 995px #fff, 704px 1815px #fff,
        1809px 712px #fff, 1503px 288px #fff, 630px 556px #fff,
        1715px 125px #fff, 353px 1878px #fff, 975px 333px #fff,
        1740px 1409px #fff, 1341px 1871px #fff, 1279px 1064px #fff,
        169px 874px #fff, 161px 528px #fff, 1671px 1669px #fff, 169px 632px #fff,
        547px 1724px #fff, 1904px 110px #fff, 679px 1670px #fff,
        196px 123px #fff, 786px 871px #fff, 1840px 324px #fff, 356px 967px #fff,
        61px 549px #fff, 99px 677px #fff, 1719px 87px #fff, 1713px 1990px #fff,
        1717px 1358px #fff, 108px 1187px #fff, 51px 869px #fff,
        1461px 902px #fff, 1034px 891px #fff, 962px 1881px #fff,
        1723px 595px #fff, 479px 901px #fff, 1546px 1823px #fff,
        285px 1208px #fff, 1056px 347px #fff, 261px 988px #fff, 466px 990px #fff,
        1657px 648px #fff, 1249px 933px #fff, 1552px 1555px #fff,
        147px 62px #fff, 292px 1157px #fff, 1816px 423px #fff, 1714px 757px #fff,
        1036px 961px #fff, 1955px 710px #fff, 1842px 516px #fff,
        479px 1870px #fff, 1579px 1445px #fff, 1225px 1309px #fff,
        1965px 566px #fff, 1575px 1072px #fff, 923px 329px #fff,
        651px 1514px #fff, 865px 1100px #fff, 782px 1873px #fff,
        115px 299px #fff, 14px 1668px #fff, 1666px 1817px #fff,
        1096px 1068px #fff, 1462px 742px #fff, 1384px 1750px #fff;
}

#stars4 {
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: 233px 1976px #fff, 1196px 1119px #fff, 646px 740px #fff,
        335px 645px #fff, 1119px 1452px #fff, 176px 1870px #fff,
        639px 1711px #fff, 647px 1388px #fff, 1516px 1108px #fff,
        464px 66px #fff, 331px 344px #fff, 772px 1189px #fff, 1516px 1850px #fff,
        1500px 1463px #fff, 1275px 876px #fff, 1107px 645px #fff,
        977px 478px #fff, 583px 1179px #fff, 284px 395px #fff, 1220px 461px #fff,
        1160px 249px #fff, 196px 865px #fff, 670px 1915px #fff,
        1449px 382px #fff, 1191px 546px #fff, 1329px 605px #fff,
        1945px 458px #fff, 995px 749px #fff, 1495px 861px #fff,
        708px 1731px #fff, 348px 653px #fff, 548px 1298px #fff,
        1606px 990px #fff, 1049px 1204px #fff, 253px 1501px #fff,
        1154px 166px #fff, 1087px 104px #fff, 1034px 1161px #fff,
        1681px 462px #fff, 577px 1897px #fff, 193px 1901px #fff,
        1701px 1755px #fff, 864px 1297px #fff, 800px 1289px #fff,
        676px 28px #fff, 185px 1341px #fff, 379px 1151px #fff,
        1224px 1725px #fff, 280px 541px #fff, 473px 1196px #fff,
        921px 1628px #fff, 969px 432px #fff, 1475px 758px #fff,
        1195px 993px #fff, 876px 1840px #fff, 1274px 1689px #fff,
        1977px 1101px #fff, 837px 527px #fff, 1785px 1610px #fff,
        1650px 1843px #fff, 1127px 1508px #fff, 401px 1050px #fff,
        51px 1105px #fff, 545px 880px #fff, 1786px 1672px #fff, 318px 260px #fff,
        568px 254px #fff, 1026px 1527px #fff, 1242px 852px #fff,
        1785px 982px #fff, 1318px 1071px #fff, 398px 1061px #fff,
        1509px 257px #fff, 599px 928px #fff, 1195px 1800px #fff,
        1254px 906px #fff, 141px 26px #fff, 1384px 1502px #fff, 476px 767px #fff,
        1973px 722px #fff, 1339px 1031px #fff, 778px 818px #fff,
        213px 1320px #fff, 184px 221px #fff, 983px 1911px #fff,
        923px 1439px #fff, 1936px 581px #fff, 1105px 625px #fff,
        325px 729px #fff, 1475px 204px #fff, 1483px 1564px #fff,
        1327px 1272px #fff, 1187px 1944px #fff, 1945px 1471px #fff,
        116px 960px #fff, 1660px 1610px #fff, 412px 1022px #fff,
        1552px 1516px #fff, 1517px 1892px #fff, 306px 829px #fff,
        1416px 462px #fff, 1575px 1460px #fff, 424px 1500px #fff,
        1530px 1169px #fff, 1388px 1608px #fff, 185px 416px #fff,
        634px 1446px #fff, 767px 479px #fff, 71px 426px #fff, 1937px 145px #fff,
        1955px 1312px #fff, 1811px 611px #fff, 1145px 569px #fff,
        1460px 676px #fff, 131px 1858px #fff, 1557px 473px #fff,
        735px 130px #fff, 112px 1531px #fff, 1312px 305px #fff,
        409px 1032px #fff, 149px 1964px #fff, 535px 1215px #fff,
        1382px 630px #fff, 1437px 1368px #fff, 362px 1181px #fff,
        388px 181px #fff, 274px 1287px #fff, 1858px 1414px #fff,
        661px 1935px #fff, 675px 1205px #fff, 1829px 1725px #fff,
        1937px 1145px #fff, 237px 908px #fff, 1059px 1185px #fff,
        824px 1248px #fff, 1167px 1730px #fff, 180px 1961px #fff,
        1663px 203px #fff, 374px 221px #fff, 724px 1883px #fff,
        970px 1362px #fff, 832px 505px #fff, 313px 233px #fff, 1909px 597px #fff,
        434px 201px #fff, 587px 995px #fff, 1833px 623px #fff, 1464px 561px #fff,
        231px 593px #fff, 1558px 1433px #fff, 1986px 1767px #fff,
        1753px 1728px #fff, 1153px 1623px #fff, 249px 229px #fff,
        1503px 1186px #fff, 1784px 137px #fff, 841px 403px #fff,
        1400px 354px #fff, 197px 499px #fff, 1188px 681px #fff, 158px 391px #fff,
        443px 1099px #fff, 723px 1445px #fff, 1408px 1235px #fff,
        1908px 195px #fff, 271px 891px #fff, 469px 1693px #fff, 580px 11px #fff,
        1533px 70px #fff, 859px 761px #fff, 1510px 1844px #fff, 421px 558px #fff,
        1132px 1453px #fff, 757px 1987px #fff, 212px 293px #fff,
        569px 323px #fff, 1404px 1394px #fff, 252px 1386px #fff,
        1668px 1857px #fff, 123px 1684px #fff, 105px 490px #fff,
        1083px 1769px #fff, 1071px 1953px #fff, 1271px 1159px #fff,
        699px 1491px #fff, 1744px 1997px #fff, 1868px 1973px #fff,
        1438px 1449px #fff, 1222px 1921px #fff, 1328px 1210px #fff,
        438px 873px #fff, 809px 780px #fff, 491px 1524px #fff, 447px 1830px #fff,
        927px 1936px #fff, 564px 691px #fff, 1784px 1747px #fff,
        1978px 1722px #fff, 1599px 1480px #fff, 1276px 729px #fff,
        731px 1174px #fff, 1586px 1711px #fff, 451px 1340px #fff,
        1075px 1899px #fff, 13px 575px #fff, 309px 1340px #fff, 981px 183px #fff,
        248px 1315px #fff, 849px 80px #fff, 1754px 1540px #fff, 73px 1432px #fff,
        1208px 1828px #fff, 65px 575px #fff, 1098px 730px #fff,
        127px 1358px #fff, 185px 19px #fff, 1222px 1679px #fff,
        1122px 315px #fff, 1906px 452px #fff, 761px 284px #fff, 813px 492px #fff,
        1344px 843px #fff, 118px 1834px #fff, 1620px 359px #fff,
        1755px 1246px #fff, 299px 1076px #fff, 1746px 158px #fff,
        6px 1635px #fff, 143px 190px #fff, 101px 468px #fff, 137px 971px #fff,
        1221px 1929px #fff, 1752px 650px #fff, 1635px 1761px #fff,
        1522px 833px #fff, 908px 153px #fff, 1044px 350px #fff,
        1151px 1940px #fff, 822px 210px #fff, 1774px 310px #fff,
        796px 1447px #fff, 1069px 1903px #fff, 217px 565px #fff,
        662px 1370px #fff, 1876px 1570px #fff, 847px 46px #fff,
        1042px 1689px #fff, 1584px 1434px #fff, 1791px 908px #fff,
        973px 908px #fff, 793px 747px #fff, 122px 483px #fff, 1137px 1374px #fff,
        1757px 1791px #fff, 513px 225px #fff, 63px 731px #fff,
        1179px 1926px #fff, 346px 18px #fff, 589px 175px #fff, 87px 302px #fff,
        380px 1295px #fff, 450px 921px #fff, 1667px 1973px #fff,
        1495px 1373px #fff, 1462px 1850px #fff, 540px 288px #fff,
        1208px 1051px #fff, 1554px 1095px #fff, 1009px 1516px #fff,
        181px 572px #fff, 165px 387px #fff, 549px 1835px #fff, 960px 16px #fff,
        1360px 403px #fff, 1251px 43px #fff, 1905px 1813px #fff,
        1106px 866px #fff, 1809px 277px #fff, 1828px 1720px #fff,
        295px 1610px #fff, 523px 166px #fff, 1069px 692px #fff,
        1292px 217px #fff, 11px 1721px #fff, 99px 1045px #fff, 51px 1584px #fff,
        1053px 266px #fff, 1287px 1235px #fff, 747px 1722px #fff,
        1542px 736px #fff, 1256px 18px #fff, 102px 609px #fff, 586px 1339px #fff,
        1843px 1697px #fff, 824px 1687px #fff, 1124px 882px #fff,
        395px 501px #fff, 1456px 672px #fff, 1472px 1648px #fff,
        1326px 1164px #fff, 777px 1672px #fff, 81px 345px #fff, 91px 386px #fff,
        243px 411px #fff, 1560px 90px #fff, 6px 1771px #fff, 1601px 616px #fff,
        1220px 1808px #fff, 1160px 836px #fff, 246px 1777px #fff,
        456px 863px #fff, 97px 1138px #fff, 1811px 942px #fff, 213px 414px #fff,
        891px 392px #fff, 1044px 927px #fff, 1856px 216px #fff, 957px 347px #fff,
        1486px 406px #fff, 838px 912px #fff, 803px 361px #fff, 564px 826px #fff,
        1597px 949px #fff, 1206px 289px #fff, 33px 1035px #fff,
        1762px 1377px #fff, 789px 1815px #fff, 1594px 1342px #fff,
        1668px 880px #fff, 1539px 1581px #fff, 1547px 53px #fff,
        861px 1433px #fff, 693px 1618px #fff, 1762px 782px #fff,
        1568px 682px #fff, 1126px 1762px #fff, 1242px 134px #fff,
        495px 959px #fff, 1606px 219px #fff, 1878px 1415px #fff,
        1652px 797px #fff, 782px 1903px #fff, 1774px 1133px #fff,
        1430px 408px #fff, 265px 394px #fff, 890px 336px #fff, 1051px 311px #fff,
        461px 1559px #fff, 1931px 91px #fff, 1160px 380px #fff,
        1442px 1058px #fff, 1157px 364px #fff, 586px 227px #fff,
        1365px 715px #fff, 1658px 1655px #fff, 1923px 1664px #fff,
        1023px 1844px #fff, 1939px 1367px #fff, 1203px 1305px #fff,
        359px 642px #fff, 1056px 425px #fff, 787px 202px #fff,
        1609px 1850px #fff, 1964px 200px #fff, 1537px 586px #fff,
        1589px 903px #fff, 1063px 1694px #fff, 760px 1185px #fff,
        597px 1396px #fff, 294px 452px #fff, 433px 818px #fff, 199px 840px #fff,
        1332px 1937px #fff, 169px 1907px #fff, 591px 834px #fff,
        1716px 1032px #fff, 45px 1879px #fff, 686px 1469px #fff,
        1520px 475px #fff, 1122px 859px #fff, 973px 1541px #fff,
        269px 477px #fff, 1390px 716px #fff, 1791px 783px #fff,
        824px 2000px #fff, 1211px 1717px #fff, 1008px 1587px #fff,
        1422px 204px #fff, 234px 556px #fff, 506px 550px #fff, 942px 1670px #fff,
        397px 853px #fff, 599px 795px #fff, 762px 1926px #fff,
        1202px 1424px #fff, 135px 1316px #fff, 1442px 1692px #fff,
        977px 652px #fff, 564px 1648px #fff, 997px 1474px #fff, 67px 1366px #fff,
        1860px 1451px #fff, 1105px 772px #fff, 1886px 1396px #fff,
        1510px 658px #fff, 976px 1544px #fff, 894px 543px #fff,
        1098px 1189px #fff, 690px 77px #fff, 770px 733px #fff, 557px 1403px #fff,
        1758px 1623px #fff, 1341px 812px #fff, 699px 967px #fff,
        277px 866px #fff, 1526px 1828px #fff, 8px 977px #fff, 1707px 952px #fff,
        12px 1900px #fff, 72px 921px #fff, 496px 1067px #fff, 1288px 1749px #fff,
        273px 984px #fff, 1197px 1991px #fff, 242px 789px #fff,
        903px 1035px #fff, 480px 1492px #fff, 102px 1331px #fff,
        738px 1343px #fff, 560px 1475px #fff, 367px 846px #fff,
        1420px 962px #fff, 1976px 892px #fff, 1911px 1763px #fff,
        1639px 1002px #fff, 437px 1522px #fff, 1906px 1025px #fff,
        730px 1364px #fff, 1127px 521px #fff, 1401px 1792px #fff,
        1954px 1066px #fff, 232px 250px #fff, 1685px 660px #fff,
        1011px 999px #fff, 1970px 790px #fff, 750px 499px #fff,
        1738px 660px #fff, 1621px 1849px #fff, 446px 52px #fff,
        1055px 1396px #fff, 1165px 1497px #fff, 1740px 1425px #fff,
        1012px 1920px #fff, 1258px 1560px #fff, 1020px 1152px #fff,
        362px 673px #fff, 1065px 975px #fff, 582px 755px #fff,
        1271px 1479px #fff, 719px 548px #fff, 1602px 879px #fff,
        590px 499px #fff, 721px 1412px #fff, 1180px 113px #fff,
        1801px 1961px #fff, 589px 941px #fff, 883px 476px #fff, 214px 890px #fff,
        1028px 892px #fff, 1107px 1832px #fff, 944px 361px #fff,
        480px 1453px #fff, 1466px 683px #fff, 981px 745px #fff,
        1968px 828px #fff, 657px 1830px #fff, 11px 1338px #fff, 179px 730px #fff,
        1713px 197px #fff, 51px 955px #fff, 1243px 319px #fff, 1175px 624px #fff,
        446px 46px #fff, 5px 1158px #fff, 82px 1352px #fff, 1877px 402px #fff,
        708px 1778px #fff, 903px 1625px #fff, 1824px 352px #fff,
        1229px 140px #fff, 1518px 24px #fff, 1017px 512px #fff, 515px 699px #fff,
        295px 265px #fff, 69px 1773px #fff, 1640px 1163px #fff, 536px 342px #fff,
        970px 1766px #fff, 560px 1416px #fff, 577px 193px #fff, 469px 9px #fff,
        466px 276px #fff, 711px 853px #fff, 401px 685px #fff, 85px 506px #fff,
        865px 558px #fff, 631px 105px #fff, 887px 866px #fff, 1704px 1001px #fff,
        1051px 1199px #fff, 275px 1909px #fff, 1462px 829px #fff,
        375px 1057px #fff, 1531px 1501px #fff, 205px 403px #fff,
        33px 1869px #fff, 967px 1176px #fff, 376px 863px #fff,
        1769px 1545px #fff, 535px 51px #fff, 1972px 1569px #fff,
        1773px 960px #fff, 487px 620px #fff, 1660px 687px #fff,
        1632px 972px #fff, 1362px 42px #fff, 479px 1655px #fff,
        1531px 1808px #fff, 1450px 1412px #fff, 1549px 170px #fff,
        1904px 1305px #fff, 1209px 48px #fff, 1933px 820px #fff,
        1623px 595px #fff, 48px 643px #fff, 179px 1754px #fff, 589px 1032px #fff,
        1199px 356px #fff, 1755px 1418px #fff, 780px 1174px #fff,
        1905px 758px #fff, 1567px 713px #fff, 1372px 705px #fff,
        456px 654px #fff, 759px 690px #fff, 452px 673px #fff, 993px 1610px #fff,
        1271px 188px #fff, 343px 1750px #fff, 1943px 1735px #fff,
        1717px 853px #fff, 1247px 303px #fff, 1314px 1895px #fff,
        1203px 489px #fff, 741px 469px #fff, 4px 246px #fff, 1515px 115px #fff,
        606px 218px #fff, 1966px 1471px #fff, 177px 87px #fff, 1575px 588px #fff,
        1136px 1386px #fff, 70px 1868px #fff, 1053px 18px #fff,
        1124px 721px #fff, 1748px 1181px #fff, 191px 1387px #fff,
        1931px 840px #fff, 1088px 1603px #fff, 634px 1255px #fff,
        814px 1434px #fff, 585px 64px #fff, 1074px 1618px #fff,
        1692px 761px #fff, 651px 643px #fff, 193px 335px #fff,
        1103px 1447px #fff, 491px 1142px #fff, 521px 408px #fff,
        536px 340px #fff, 411px 1091px #fff, 1646px 193px #fff,
        1595px 1285px #fff, 870px 1349px #fff, 1085px 1013px #fff,
        204px 1864px #fff, 1359px 299px #fff, 807px 964px #fff, 219px 509px #fff,
        36px 1227px #fff, 702px 1873px #fff, 1471px 934px #fff,
        1763px 792px #fff, 973px 1957px #fff, 987px 68px #fff, 593px 1282px #fff,
        1900px 607px #fff, 407px 1659px #fff, 587px 17px #fff, 632px 158px #fff;
    -webkit-animation: animStar 600s linear infinite;
    -moz-animation: animStar 600s linear infinite;
    -ms-animation: animStar 600s linear infinite;
    animation: animStar 600s linear infinite;
}

#stars4:after {
    content: " ";
    position: absolute;
    top: 2000px;
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: 233px 1976px #fff, 1196px 1119px #fff, 646px 740px #fff,
        335px 645px #fff, 1119px 1452px #fff, 176px 1870px #fff,
        639px 1711px #fff, 647px 1388px #fff, 1516px 1108px #fff,
        464px 66px #fff, 331px 344px #fff, 772px 1189px #fff, 1516px 1850px #fff,
        1500px 1463px #fff, 1275px 876px #fff, 1107px 645px #fff,
        977px 478px #fff, 583px 1179px #fff, 284px 395px #fff, 1220px 461px #fff,
        1160px 249px #fff, 196px 865px #fff, 670px 1915px #fff,
        1449px 382px #fff, 1191px 546px #fff, 1329px 605px #fff,
        1945px 458px #fff, 995px 749px #fff, 1495px 861px #fff,
        708px 1731px #fff, 348px 653px #fff, 548px 1298px #fff,
        1606px 990px #fff, 1049px 1204px #fff, 253px 1501px #fff,
        1154px 166px #fff, 1087px 104px #fff, 1034px 1161px #fff,
        1681px 462px #fff, 577px 1897px #fff, 193px 1901px #fff,
        1701px 1755px #fff, 864px 1297px #fff, 800px 1289px #fff,
        676px 28px #fff, 185px 1341px #fff, 379px 1151px #fff,
        1224px 1725px #fff, 280px 541px #fff, 473px 1196px #fff,
        921px 1628px #fff, 969px 432px #fff, 1475px 758px #fff,
        1195px 993px #fff, 876px 1840px #fff, 1274px 1689px #fff,
        1977px 1101px #fff, 837px 527px #fff, 1785px 1610px #fff,
        1650px 1843px #fff, 1127px 1508px #fff, 401px 1050px #fff,
        51px 1105px #fff, 545px 880px #fff, 1786px 1672px #fff, 318px 260px #fff,
        568px 254px #fff, 1026px 1527px #fff, 1242px 852px #fff,
        1785px 982px #fff, 1318px 1071px #fff, 398px 1061px #fff,
        1509px 257px #fff, 599px 928px #fff, 1195px 1800px #fff,
        1254px 906px #fff, 141px 26px #fff, 1384px 1502px #fff, 476px 767px #fff,
        1973px 722px #fff, 1339px 1031px #fff, 778px 818px #fff,
        213px 1320px #fff, 184px 221px #fff, 983px 1911px #fff,
        923px 1439px #fff, 1936px 581px #fff, 1105px 625px #fff,
        325px 729px #fff, 1475px 204px #fff, 1483px 1564px #fff,
        1327px 1272px #fff, 1187px 1944px #fff, 1945px 1471px #fff,
        116px 960px #fff, 1660px 1610px #fff, 412px 1022px #fff,
        1552px 1516px #fff, 1517px 1892px #fff, 306px 829px #fff,
        1416px 462px #fff, 1575px 1460px #fff, 424px 1500px #fff,
        1530px 1169px #fff, 1388px 1608px #fff, 185px 416px #fff,
        634px 1446px #fff, 767px 479px #fff, 71px 426px #fff, 1937px 145px #fff,
        1955px 1312px #fff, 1811px 611px #fff, 1145px 569px #fff,
        1460px 676px #fff, 131px 1858px #fff, 1557px 473px #fff,
        735px 130px #fff, 112px 1531px #fff, 1312px 305px #fff,
        409px 1032px #fff, 149px 1964px #fff, 535px 1215px #fff,
        1382px 630px #fff, 1437px 1368px #fff, 362px 1181px #fff,
        388px 181px #fff, 274px 1287px #fff, 1858px 1414px #fff,
        661px 1935px #fff, 675px 1205px #fff, 1829px 1725px #fff,
        1937px 1145px #fff, 237px 908px #fff, 1059px 1185px #fff,
        824px 1248px #fff, 1167px 1730px #fff, 180px 1961px #fff,
        1663px 203px #fff, 374px 221px #fff, 724px 1883px #fff,
        970px 1362px #fff, 832px 505px #fff, 313px 233px #fff, 1909px 597px #fff,
        434px 201px #fff, 587px 995px #fff, 1833px 623px #fff, 1464px 561px #fff,
        231px 593px #fff, 1558px 1433px #fff, 1986px 1767px #fff,
        1753px 1728px #fff, 1153px 1623px #fff, 249px 229px #fff,
        1503px 1186px #fff, 1784px 137px #fff, 841px 403px #fff,
        1400px 354px #fff, 197px 499px #fff, 1188px 681px #fff, 158px 391px #fff,
        443px 1099px #fff, 723px 1445px #fff, 1408px 1235px #fff,
        1908px 195px #fff, 271px 891px #fff, 469px 1693px #fff, 580px 11px #fff,
        1533px 70px #fff, 859px 761px #fff, 1510px 1844px #fff, 421px 558px #fff,
        1132px 1453px #fff, 757px 1987px #fff, 212px 293px #fff,
        569px 323px #fff, 1404px 1394px #fff, 252px 1386px #fff,
        1668px 1857px #fff, 123px 1684px #fff, 105px 490px #fff,
        1083px 1769px #fff, 1071px 1953px #fff, 1271px 1159px #fff,
        699px 1491px #fff, 1744px 1997px #fff, 1868px 1973px #fff,
        1438px 1449px #fff, 1222px 1921px #fff, 1328px 1210px #fff,
        438px 873px #fff, 809px 780px #fff, 491px 1524px #fff, 447px 1830px #fff,
        927px 1936px #fff, 564px 691px #fff, 1784px 1747px #fff,
        1978px 1722px #fff, 1599px 1480px #fff, 1276px 729px #fff,
        731px 1174px #fff, 1586px 1711px #fff, 451px 1340px #fff,
        1075px 1899px #fff, 13px 575px #fff, 309px 1340px #fff, 981px 183px #fff,
        248px 1315px #fff, 849px 80px #fff, 1754px 1540px #fff, 73px 1432px #fff,
        1208px 1828px #fff, 65px 575px #fff, 1098px 730px #fff,
        127px 1358px #fff, 185px 19px #fff, 1222px 1679px #fff,
        1122px 315px #fff, 1906px 452px #fff, 761px 284px #fff, 813px 492px #fff,
        1344px 843px #fff, 118px 1834px #fff, 1620px 359px #fff,
        1755px 1246px #fff, 299px 1076px #fff, 1746px 158px #fff,
        6px 1635px #fff, 143px 190px #fff, 101px 468px #fff, 137px 971px #fff,
        1221px 1929px #fff, 1752px 650px #fff, 1635px 1761px #fff,
        1522px 833px #fff, 908px 153px #fff, 1044px 350px #fff,
        1151px 1940px #fff, 822px 210px #fff, 1774px 310px #fff,
        796px 1447px #fff, 1069px 1903px #fff, 217px 565px #fff,
        662px 1370px #fff, 1876px 1570px #fff, 847px 46px #fff,
        1042px 1689px #fff, 1584px 1434px #fff, 1791px 908px #fff,
        973px 908px #fff, 793px 747px #fff, 122px 483px #fff, 1137px 1374px #fff,
        1757px 1791px #fff, 513px 225px #fff, 63px 731px #fff,
        1179px 1926px #fff, 346px 18px #fff, 589px 175px #fff, 87px 302px #fff,
        380px 1295px #fff, 450px 921px #fff, 1667px 1973px #fff,
        1495px 1373px #fff, 1462px 1850px #fff, 540px 288px #fff,
        1208px 1051px #fff, 1554px 1095px #fff, 1009px 1516px #fff,
        181px 572px #fff, 165px 387px #fff, 549px 1835px #fff, 960px 16px #fff,
        1360px 403px #fff, 1251px 43px #fff, 1905px 1813px #fff,
        1106px 866px #fff, 1809px 277px #fff, 1828px 1720px #fff,
        295px 1610px #fff, 523px 166px #fff, 1069px 692px #fff,
        1292px 217px #fff, 11px 1721px #fff, 99px 1045px #fff, 51px 1584px #fff,
        1053px 266px #fff, 1287px 1235px #fff, 747px 1722px #fff,
        1542px 736px #fff, 1256px 18px #fff, 102px 609px #fff, 586px 1339px #fff,
        1843px 1697px #fff, 824px 1687px #fff, 1124px 882px #fff,
        395px 501px #fff, 1456px 672px #fff, 1472px 1648px #fff,
        1326px 1164px #fff, 777px 1672px #fff, 81px 345px #fff, 91px 386px #fff,
        243px 411px #fff, 1560px 90px #fff, 6px 1771px #fff, 1601px 616px #fff,
        1220px 1808px #fff, 1160px 836px #fff, 246px 1777px #fff,
        456px 863px #fff, 97px 1138px #fff, 1811px 942px #fff, 213px 414px #fff,
        891px 392px #fff, 1044px 927px #fff, 1856px 216px #fff, 957px 347px #fff,
        1486px 406px #fff, 838px 912px #fff, 803px 361px #fff, 564px 826px #fff,
        1597px 949px #fff, 1206px 289px #fff, 33px 1035px #fff,
        1762px 1377px #fff, 789px 1815px #fff, 1594px 1342px #fff,
        1668px 880px #fff, 1539px 1581px #fff, 1547px 53px #fff,
        861px 1433px #fff, 693px 1618px #fff, 1762px 782px #fff,
        1568px 682px #fff, 1126px 1762px #fff, 1242px 134px #fff,
        495px 959px #fff, 1606px 219px #fff, 1878px 1415px #fff,
        1652px 797px #fff, 782px 1903px #fff, 1774px 1133px #fff,
        1430px 408px #fff, 265px 394px #fff, 890px 336px #fff, 1051px 311px #fff,
        461px 1559px #fff, 1931px 91px #fff, 1160px 380px #fff,
        1442px 1058px #fff, 1157px 364px #fff, 586px 227px #fff,
        1365px 715px #fff, 1658px 1655px #fff, 1923px 1664px #fff,
        1023px 1844px #fff, 1939px 1367px #fff, 1203px 1305px #fff,
        359px 642px #fff, 1056px 425px #fff, 787px 202px #fff,
        1609px 1850px #fff, 1964px 200px #fff, 1537px 586px #fff,
        1589px 903px #fff, 1063px 1694px #fff, 760px 1185px #fff,
        597px 1396px #fff, 294px 452px #fff, 433px 818px #fff, 199px 840px #fff,
        1332px 1937px #fff, 169px 1907px #fff, 591px 834px #fff,
        1716px 1032px #fff, 45px 1879px #fff, 686px 1469px #fff,
        1520px 475px #fff, 1122px 859px #fff, 973px 1541px #fff,
        269px 477px #fff, 1390px 716px #fff, 1791px 783px #fff,
        824px 2000px #fff, 1211px 1717px #fff, 1008px 1587px #fff,
        1422px 204px #fff, 234px 556px #fff, 506px 550px #fff, 942px 1670px #fff,
        397px 853px #fff, 599px 795px #fff, 762px 1926px #fff,
        1202px 1424px #fff, 135px 1316px #fff, 1442px 1692px #fff,
        977px 652px #fff, 564px 1648px #fff, 997px 1474px #fff, 67px 1366px #fff,
        1860px 1451px #fff, 1105px 772px #fff, 1886px 1396px #fff,
        1510px 658px #fff, 976px 1544px #fff, 894px 543px #fff,
        1098px 1189px #fff, 690px 77px #fff, 770px 733px #fff, 557px 1403px #fff,
        1758px 1623px #fff, 1341px 812px #fff, 699px 967px #fff,
        277px 866px #fff, 1526px 1828px #fff, 8px 977px #fff, 1707px 952px #fff,
        12px 1900px #fff, 72px 921px #fff, 496px 1067px #fff, 1288px 1749px #fff,
        273px 984px #fff, 1197px 1991px #fff, 242px 789px #fff,
        903px 1035px #fff, 480px 1492px #fff, 102px 1331px #fff,
        738px 1343px #fff, 560px 1475px #fff, 367px 846px #fff,
        1420px 962px #fff, 1976px 892px #fff, 1911px 1763px #fff,
        1639px 1002px #fff, 437px 1522px #fff, 1906px 1025px #fff,
        730px 1364px #fff, 1127px 521px #fff, 1401px 1792px #fff,
        1954px 1066px #fff, 232px 250px #fff, 1685px 660px #fff,
        1011px 999px #fff, 1970px 790px #fff, 750px 499px #fff,
        1738px 660px #fff, 1621px 1849px #fff, 446px 52px #fff,
        1055px 1396px #fff, 1165px 1497px #fff, 1740px 1425px #fff,
        1012px 1920px #fff, 1258px 1560px #fff, 1020px 1152px #fff,
        362px 673px #fff, 1065px 975px #fff, 582px 755px #fff,
        1271px 1479px #fff, 719px 548px #fff, 1602px 879px #fff,
        590px 499px #fff, 721px 1412px #fff, 1180px 113px #fff,
        1801px 1961px #fff, 589px 941px #fff, 883px 476px #fff, 214px 890px #fff,
        1028px 892px #fff, 1107px 1832px #fff, 944px 361px #fff,
        480px 1453px #fff, 1466px 683px #fff, 981px 745px #fff,
        1968px 828px #fff, 657px 1830px #fff, 11px 1338px #fff, 179px 730px #fff,
        1713px 197px #fff, 51px 955px #fff, 1243px 319px #fff, 1175px 624px #fff,
        446px 46px #fff, 5px 1158px #fff, 82px 1352px #fff, 1877px 402px #fff,
        708px 1778px #fff, 903px 1625px #fff, 1824px 352px #fff,
        1229px 140px #fff, 1518px 24px #fff, 1017px 512px #fff, 515px 699px #fff,
        295px 265px #fff, 69px 1773px #fff, 1640px 1163px #fff, 536px 342px #fff,
        970px 1766px #fff, 560px 1416px #fff, 577px 193px #fff, 469px 9px #fff,
        466px 276px #fff, 711px 853px #fff, 401px 685px #fff, 85px 506px #fff,
        865px 558px #fff, 631px 105px #fff, 887px 866px #fff, 1704px 1001px #fff,
        1051px 1199px #fff, 275px 1909px #fff, 1462px 829px #fff,
        375px 1057px #fff, 1531px 1501px #fff, 205px 403px #fff,
        33px 1869px #fff, 967px 1176px #fff, 376px 863px #fff,
        1769px 1545px #fff, 535px 51px #fff, 1972px 1569px #fff,
        1773px 960px #fff, 487px 620px #fff, 1660px 687px #fff,
        1632px 972px #fff, 1362px 42px #fff, 479px 1655px #fff,
        1531px 1808px #fff, 1450px 1412px #fff, 1549px 170px #fff,
        1904px 1305px #fff, 1209px 48px #fff, 1933px 820px #fff,
        1623px 595px #fff, 48px 643px #fff, 179px 1754px #fff, 589px 1032px #fff,
        1199px 356px #fff, 1755px 1418px #fff, 780px 1174px #fff,
        1905px 758px #fff, 1567px 713px #fff, 1372px 705px #fff,
        456px 654px #fff, 759px 690px #fff, 452px 673px #fff, 993px 1610px #fff,
        1271px 188px #fff, 343px 1750px #fff, 1943px 1735px #fff,
        1717px 853px #fff, 1247px 303px #fff, 1314px 1895px #fff,
        1203px 489px #fff, 741px 469px #fff, 4px 246px #fff, 1515px 115px #fff,
        606px 218px #fff, 1966px 1471px #fff, 177px 87px #fff, 1575px 588px #fff,
        1136px 1386px #fff, 70px 1868px #fff, 1053px 18px #fff,
        1124px 721px #fff, 1748px 1181px #fff, 191px 1387px #fff,
        1931px 840px #fff, 1088px 1603px #fff, 634px 1255px #fff,
        814px 1434px #fff, 585px 64px #fff, 1074px 1618px #fff,
        1692px 761px #fff, 651px 643px #fff, 193px 335px #fff,
        1103px 1447px #fff, 491px 1142px #fff, 521px 408px #fff,
        536px 340px #fff, 411px 1091px #fff, 1646px 193px #fff,
        1595px 1285px #fff, 870px 1349px #fff, 1085px 1013px #fff,
        204px 1864px #fff, 1359px 299px #fff, 807px 964px #fff, 219px 509px #fff,
        36px 1227px #fff, 702px 1873px #fff, 1471px 934px #fff,
        1763px 792px #fff, 973px 1957px #fff, 987px 68px #fff, 593px 1282px #fff,
        1900px 607px #fff, 407px 1659px #fff, 587px 17px #fff, 632px 158px #fff;
}

@-webkit-keyframes animStar {
    from {
        -webkit-transform: translateY(0px);
    }
    to {
        -webkit-transform: translateY(-2000px);
    }
}

@-moz-keyframes animStar {
    from {
        -moz-transform: translateY(0px);
    }
    to {
        -moz-transform: translateY(-2000px);
    }
}

@-ms-keyframes animStar {
    from {
        -ms-transform: translateY(0px);
    }
    to {
        -ms-transform: translateY(-2000px);
    }
}

@keyframes animStar {
    from {
        transform: translateY(0px);
    }
    to {
        transform: translateY(-2000px);
    }
}
</style>
